
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import _WidgetsInTemplateMixin from 'dijit/_WidgetsInTemplateMixin';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MainPropertiesV2.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';
import date from 'dojo/date';
import stamp from 'dojo/date/stamp';
import query from 'dojo/query';
import Observable from 'dojo/store/Observable';
import Memory from 'dojo/store/Memory';
import domConstruct from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import dojoDate from 'dojo/date';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/GenericDialog/GenericDialog";
import Toaster from '../../../moreCore/UI/Toaster_TS/Toaster';
import "../../../moreCore/UI/Toaster_TS/Toaster";
import SearchPanel from '../SearchPanel/SearchPanel';
import "../SearchPanel/SearchPanel";
import DatePicker from '../DatePicker/DatePicker';
import "../DatePicker/DatePicker";
import UserProperties from '../UserProperties/UserProperties';
import "../UserProperties/UserProperties";
//import moreCoreCalendar = require("../../../moreCore/UI/moreCoreCalendar/moreCoreCalendar/moreCoreCalendar");
//import "../../../moreCore/UI/moreCoreCalendar/moreCoreCalendar/moreCoreCalendar";
import Calendar_Buttons from '../../../moreCore/UI/moreCoreCalendar/Calendar_Buttons/Calendar_Buttons';
import "../../../moreCore/UI/moreCoreCalendar/Calendar_Buttons/Calendar_Buttons";
import SelectEntityDialog from '../../../moreCore/UI/SelectEntityDialog/SelectEntityDialog';
import SyncFusionCalendar from '../../../moreCore/UI/SyncFusionCalendar/SyncFusionCalendar/SyncFusionCalendar';
import "../../../moreCore/UI/SyncFusionCalendar/SyncFusionCalendar/SyncFusionCalendar";
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import { EvBookingView, ProjectView } from "../../_loadingHelpers/VAMv2";
import { VAMclassNames } from "../../_loadingHelpers/VAMv2Types";
import { PrivateAppointmentView, PAclassNames } from "../../_loadingHelpers/PrivateAppointment";
import EvBookingEditor from '../../EvBooking/EvBookingEditorV2';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import "../../../moreCore/UI/CheckBox/CheckBox";
import _EntityViewMixin from '../../../moreCore/UI/EntityBased/EntityView/EntityView';
import Edit from '../../../moreCore/UI/Edit/Edit';
import CalendarListView from '../../../moreCore/UI/moreCoreCalendar/ListView/CalendarListView';
import { ColorHelpers, DateHelpers, EntityHelpers, StringHelpers, ToasterHelpers, TranslationHelpers } from "../../../more/Helpers";
import PrivateAppointmentEditor from '../../PrivateAppointmentEditor/PrivateAppointmentEditor';
import { SyncFusionCalendarTypes } from "../../../moreCore/UI/SyncFusionCalendar/SyncFusionCalendar/SyncFusionCalendarTypes";
import Button from '../../../moreCore/UI/Button/Button';
import "../../../moreCore/UI/Button/Button";
import { SaleClasses } from "../../PlanningObjectOperator/PlanningObjectOperatorTypes";
import PlanningObjectOperatorView from '../../PlanningObjectOperator/PlanningObjectOperatorView';
import { GoogleSyncSettings } from "../../../moreCore/System/GoogleSyncTypes";
import ProgressBar from '../../../moreCore/UI/ProgressBar/ProgressBar';
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import "../../../moreCore/UI/SelectBox/SelectBox";
import { WebcalendarTypes } from "../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";
import TravelBookingView from '../../ProjectWizardV2/Travel/TravelBookingForm/TravelBookinView';
import methodHooks from 'more/mdsMethodHooks';


/*
import ExtendedCalendar = require("../ExtendedCalendar/ExtendedCalendar");
import "../ExtendedCalendar/ExtendedCalendar";
*/
//import SelectBox = require("../../../moreCore/UI/SelectBox/SelectBox");



interface FilterresultData {
    items: Array<WebcalendarTypes.WebCalendarItemData_Default>,
    itemCount: number,
    DataGroupValues: Array<string>,
    startIndex?: number,
    nextIndex?: number,
    requestID?: string
    holidays?: Array<WebcalendarTypes.Holiday>;
    singleItemUpdate?: boolean;
};

interface colorAttributeRegistryObj { entity_classname: string, tmp_class_printname: string, colorAttributes: Array<WebcalendarTypes.WebCalendar_ColorAttribute> }

interface _RendererItem { Classname: string, Default_BackColor: string, Default_TextColor: string, allDay: boolean, bOverrideColoration: boolean, coloration: Array<{ ID: string, Classname: string, BackColor: string, TextColor: string }> }


interface AppointmentViewResponse<T> {
    isHTMLdetailtext: boolean,
    content: string,
    entity?: T
}

interface lastUserSettings {
    id: string;
    userId: string;
    calendars: Array<userCalendarSettings>;
    previousSelectedCalendarId: string;
}
interface userCalendarSettings {
    calendarId: string;
    lastSetViewMode: WebcalendarTypes.WebCalendar_ViewModes;
    colors: Array<{ entity_classname: string, value: string }>
    selectedFilterIds: Array<string>;
    deselectedFilterIds: Array<string>;
    selectedSubfilterIds: Array<string>;
    deselectedSubfilterIds: Array<string>;
    showEndTime: boolean;
    showStartTime: boolean;
    autoAdjust: boolean;
    scaleFactor: number;
    showDataGroups: boolean;
    showEmptyGroups: boolean;
    showTimeIndicator: boolean;
    YearViewMonthsCount: number;
    YearViewFirstMonth: number;
}

interface SubFilterEntry {
    htFilter: WebcalendarTypes.WebCalendar_SubfilterAssignment,
    button: MdsLax<InstanceType<typeof Button>>,
    checked: boolean,
    ID: string,
    parentFilterID: string
}

interface FilterEntry {
    htFilter: WebcalendarTypes.WebCalendar_FilterAssignment,
    node: HTMLElement,
    buttonContainer: HTMLElement,
    buttonNode: HTMLElement,
    subfiltersSectionNode: HTMLElement,
    subfiltersContainerNode: HTMLElement,
    subfilters: Array<SubFilterEntry>,
    checked: boolean,
    ID: string
}

type viewbehaviour = "calendar" | "timeline" | "listview";
class MainPropertiesV2 extends methodHooks(compose(_WidgetBaseSP, _TemplatedMixin, _WidgetsInTemplateMixin)) {
    templateString: any = template;

    ////-----------------------------nodes START
    private datePicker: MdsLax<InstanceType<typeof DatePicker>>;
    private userProperties: MdsLax<InstanceType<typeof UserProperties>>;

    private searchPane: HTMLElement;
    private searchPanel: MdsLax<InstanceType<typeof SearchPanel>>;

    private toaster: MdsLax<InstanceType<typeof Toaster>>;
    syncFusionCalendar: MdsLax<InstanceType<typeof SyncFusionCalendar>> = null;
    private listView: MdsLax<InstanceType<typeof CalendarListView>> = null;
    private selectedCalendarConfig: WebcalendarTypes.WebCalendar_Config;
    private calendarButtons: MdsLax<InstanceType<typeof Calendar_Buttons>>;
    itemView: MdsLax<InstanceType<typeof _EntityViewMixin<any>>> = null;

    private controlContainer: HTMLElement;
    private controlContainerTitle: HTMLElement;
    private divSidebar: HTMLElement;
    private datePane: HTMLElement;
    private dateContainer: HTMLElement;
    private yearViewPane: HTMLElement;
    private yearViewContainer: HTMLElement;
    private inputYearViewStartMonth: MdsLax<InstanceType<typeof SelectBox>>;
    private inputYearViewMonthCount: MdsLax<InstanceType<typeof SelectBox>>;
    private btnMobileDate: HTMLButtonElement;
    private resourcesPane: HTMLElement;
    private resourcesContainer: HTMLElement;
    private resourcesTogglesContainer: HTMLElement;
    private btnMobileResources: HTMLButtonElement;
    private filterPane: HTMLElement;
    private filterContainer: HTMLElement;
    private filterContainerList: HTMLElement;
    private btnMobileFilter: HTMLButtonElement;
    private btnMobileYearView: HTMLButtonElement;
    private colorationPane: HTMLElement;
    private colorationContainer: HTMLElement;
    private colorationSelectContainer: HTMLElement;
    private btnMobileColoration: HTMLButtonElement;
    private viewOptionsPane: HTMLElement;
    private viewOptionsContainer: HTMLElement;
    private btnMobileViewOptions: HTMLButtonElement;
    private autoAdjust_container: HTMLElement;
    private cbAutoAdjust: HTMLInputElement;
    private txtCurrentScale: HTMLElement;
    private calendarZoomContainer: HTMLElement;
    private btnAutoAdjust: HTMLButtonElement;
    private data_grouping_container: HTMLElement;
    private cbEnableDatagrouping: HTMLInputElement;
    private cbShowEmptyGroups: HTMLInputElement;
    private btnEnableDatagrouping: HTMLButtonElement;
    private btnShowEmptyGroups: HTMLButtonElement;
    private showTimeIndicator_container: HTMLElement;
    private cbShowTimeIndicator: HTMLInputElement;
    private btnShowTimeIndicator: HTMLButtonElement;
    private hideColumHeadIfNeeded_container: HTMLElement;
    private cbHideColumHeadIfNeeded: HTMLInputElement;
    private btnHideColumHeadIfNeeded: HTMLButtonElement;
    private editingButtonsContainer: HTMLElement;
    private cbShowEndTime: HTMLInputElement;
    private cbShowStartTime: HTMLInputElement;
    private cbShowGoogleAppointmentsInEvis: HTMLInputElement;
    private btnShowEndTime: HTMLButtonElement;
    private showStartTime_container: HTMLElement;
    private btnShowStartTime: HTMLButtonElement;
    private btnShowGoogleAppointmentsInEvis: HTMLButtonElement;
    private userContainer: HTMLElement;
    private btnMobileUser: HTMLButtonElement;
    private calendarView_container: HTMLElement;
    private listView_container: HTMLElement;
    private customPanesContainer: HTMLDivElement;
    private googleAppointment_container: HTMLDivElement;
    private paneButtons_mobileView_container: HTMLDivElement;
    private loadingMessage: HTMLHeadingElement;

    private inputQuicksearch: MdsLax<InstanceType<typeof Edit>>;
    private quickSearchContainer: HTMLElement;

    ////-----------------------------nodes END
    //// properties ----------------------START
    private resourcesPaneHasCustomContent: boolean = false;
    private filterPaneHasCustomContent: boolean = false;
    private userPaneHasCustomContent: boolean = false;
    private colorationPaneHasCustomContent: boolean = false;
    private viewOptionsPaneHasCustomContent: boolean = false;
    private datePaneHasCustomContent: boolean = false;

    private main: any = null;
    private data: any = null;
    private customPanes: Array<WebcalendarTypes.WebCalendar_Pane>;
    private store: any = null;
    private baseStore: any = null;
    private calendarConfig: WebcalendarTypes.calendarConfig = null;
    private sessionData: object = null;
    private isDndEditingEnabled: boolean = false; // ob editierung als prozss überhaupt zugelassen ist
    //private lastGetFilterDataReponse: string = null;
    private _lastLoadedResources: Array<WebcalendarTypes.WebCalendarResourceData<any>> = null;
    private _getResourcesDataRequest: any = null;
    private _getResourcesDataSourceRequest: any = null;
    private _getFilterDataRequest: dojo.request.Promise<any> = null;
    private refreshDisplayTimeout: number = null;
    private colorationAttrRegistry: Array<colorAttributeRegistryObj> = []; // Array<{entity_calssname: string, tmp_class_printname:string, colorAttributes : Array<colorAttributes>}>
    private itemEditChangesRegistry: Array<{ item: object }> = [];
    private editToastUUID: Function = null;
    private isEditingLocked: boolean = false; // ob der schlossknopf zu oder auf ist
    //private resourcesConfigCalenderId: string = null;
    private resourceGroupRegistry: Array<WebcalendarTypes.WebCalendarResourceCheckboxes> = [];
    //private filterCheckboxes: Array<HTMLElement> = [];
    private filterReg: Record<string, FilterEntry>;
    private subfilterReg: Record<string, SubFilterEntry>;
    private lastDataGroupValues: any[] = [];
    private itemClickFunction: Function;
    private gridDoubleClickFunction: Function;
    private resourceClickFunction: Function;
    private detailviewPropertymap: Array<{ propertyname: string, label: string }> = [];
    private currentPreConfig: WebcalendarTypes.WebCalendarMainPropertiesConfig = null;

    private calendarInterval: WebcalendarTypes.WebCalendar_ViewTypes = WebcalendarTypes.WebCalendar_ViewTypes.week;
    private previousViewBehaviour: viewbehaviour = "calendar";
    private viewBehaviour: viewbehaviour = "calendar";
    private calendarIntervalSteps: number = 1;

    private _itemRequest: any = null;
    private __resourcesDataUrl: string = "Calendar/GetResourceDescriptors";
    private __resourcesDataFunction: string = null;
    private __filterDataFunction: string = "Webtool_API_Webcalendar__GetFilterData";
    private __filterDataAdditionArgs: Record<string,string> = {};
    private __requestItemLimit: number = 500;
    private __searchSettings: any = null;
    private __displaySettings: WebcalendarTypes.WebCalendarDisplaySettings = {
        b_show_end_time: null,
        hideColumnHead: false,
        b_allow_view_2weeks: null,
        b_allow_view_3days: null,
        b_allow_view_day: null,
        b_allow_view_month: null,
        b_allow_view_week: null,
        b_allow_view_list: null,
        b_show_allday_events_with_full_hours: null,
        b_show_datagroups: null,
        b_show_empty_groups: null,
        b_show_timeindicator: null
    };
    private _overrideViewMode: WebcalendarTypes.WebCalendar_ViewModes = null;
    private _itemClickTimeout: any = null;
    private _colorationSelectList: { selectNodes: Array<HTMLElement>, classNames: string[] };

    //private lastSetViewmode: WebcalendarTypes.WebCalendar_ViewModes;
    //private dateStart: Date;
    //private dateEnd: Date;
    public enableBookingCreation: boolean = false;
    private _loadCalendarDataCallback: Function;

    private currentBookingEditor: MdsLax<InstanceType<typeof EvBookingEditor>> = null;
    private _editorReadyHandle: dojo.WatchHandle;
    private bookingEditingEnabledForCurrentUser: boolean = false;
    private enableBookingCreationToggle: MdsLax<InstanceType<typeof CheckBox>>;

    private currentPrivateAppointmentEditor: MdsLax<InstanceType<typeof PrivateAppointmentEditor>> = null;
    public enablePrivAppointmentCreation: boolean = false;
    private enablePrivAppointmentCreationToggle: MdsLax<InstanceType<typeof CheckBox>>;

    public enablePlanninObjectOperatorCreation: boolean = false;
    private forceReload: boolean = false;

    private _enableLocalUserSettings: boolean = false;


    private googleSyncAvailable: boolean = false;


    //UNUSED?
    //mainHeading: HTMLElement;
    //toolbar: HTMLElement;
    //showEndTime_container: HTMLElement;
    //defaultPanes: Array<WebCalendar_Pane>;
    //decreaseArrowNode: Array<any> = [];
    //onlyFilledGroups: Array<any> = [];
    /*
    loadingRequirements: object = {
        colorationAttributes: 0,
        filters: 0
    };
    */
    //itemOverlapPercentage: number = 50; //integer, default


    //// properties ----------------------END

    //// methods ---------------------------START

    _setupSubscriptions(): void {
        super._setupSubscriptions.apply(this, arguments as any);

        this.addSubscription("UserProperties/calendarConfig", lang.hitch(this, this.setCalendarConfig)); //FIXME - evtl race condition?
        this.addSubscription("UserProperties/createCalendar", lang.hitch(this, this._createCalendar));
        this.addSubscription("UserProperties/errorLoading", lang.hitch(this, this._onErrorUserProperties));
        //this.addSubscription("ExtendedCAlendar/closeSidebar", lang.hitch(this, this._closeSidebar));
        this.addSubscription("sidebar/opened", lang.hitch(this, function (message) { this.onOpeningNavBar(message.sidebarWidth); }));
        this.addSubscription("sidebar/closed", lang.hitch(this, this.onClosingNavBar));
        //this.addSubscription("itemEitGesture_end", lang.hitch(this, function (e) { this._onItemEditGesture_end(e); }));
        this.addSubscription("calendarSearchSelect/showEntity", lang.hitch(this, function (entity) { this._showCalendarEntity(entity) }));
        this.addSubscription("WebCalendar/ShowToast", lang.hitch(this, this.publishToastMessage));

        this.addSubscription("PrivateAppointment/Saved", lang.hitch(this, this._onEditorSaved));
        this.addSubscription("PrivateAppointment/Deleted", lang.hitch(this, this._onBookingDeleted));

        //this.addSubscription("EvBooking/Saved", lang.hitch(this, this._onEditorSaved));
        //this.addSubscription("EvBooking/Deleted", lang.hitch(this, this._onBookingDeleted));

        this.addSubscription("EvBookingEditor/_onEditorFormSaveClickNotDirty", lang.hitch(this, function () {
            this.publishToastMessage(this.translate("EvBookingditor_saveClick_notDirty"))
        }));

        // sonst warten wir darauf
        this.addSubscription("/Session/CheckForExistingSession", lang.hitch(this, this._onOpenSession));

        this.addSubscription("calendar/loadData", lang.hitch(this, this.loadDataOfRange_Delayed, null));
    }

    private _onErrorUserProperties(error: any) {
        //alert("Error loading user config!\r\n" + error.Message);
        this.showToast({
            title: "Error loading user config!",
            iconClass: ToasterHelpers.ToasterIcons.error,
            timeout: -1,
            message: error.Message
        });

        this.StandbyStop();
    }

    private _onEditorSaved(response) {
        console.log("_onEditorSaved", response);
        //this.showToast({
        //    title: this.translate("EvBookingditor_saveData_success"),
        //    iconClass: toasterIcons.confirmCheck
        //});

        if (this.viewBehaviour == "listview") this.forceReload = true;
        this.loadDataOfRange_Delayed();

    }

    private _onBookingDeleted(response) {
        console.log(this.id + " _onBookingDeleted", response);

        this.loadDataOfRange_Delayed();
    }

    _onOpenSession(currentSessionData: SessionData): void {



    }

    private _getUserSettingsArrayFromStorage(): Array<lastUserSettings> {
        let strItem = window.localStorage.getItem("ego_CalendarSettings");

        let storageDataArray: Array<lastUserSettings> = [];
        if (!this._enableLocalUserSettings) return storageDataArray;
        if (strItem) {
            try {
                storageDataArray = JSON.parse(strItem);
            } catch (ex) {

            }
        }

        return storageDataArray;
    }

    private _getUserSettingsFromStorage(targetStorageId?: string, targetUserId?: string): lastUserSettings {

        if (!targetStorageId) targetStorageId = location.origin + location.pathname;
        if (!targetUserId) targetUserId = this.getCurrentUserId();
        if (!targetUserId) return null;

        let storageDataArray = this._getUserSettingsArrayFromStorage();

        for (let storage of storageDataArray) {
            if (storage.id == targetStorageId && storage.userId == targetUserId) {
                return storage;
                break;
            }
        }
        return null;
        //return storageDataArray;
    }

    private getUserCalendarSettingsFromStore(targetCalendarId?: string): userCalendarSettings {
        let key = location.origin + location.pathname;
        let storageData: lastUserSettings = this._getUserSettingsFromStorage(key);        

        if (!storageData) {
            storageData = {
                id: key,
                previousSelectedCalendarId: null,
                calendars: [],
                userId: this.getCurrentUserId()
            };
            let storageDataArray = this._getUserSettingsArrayFromStorage();

            storageDataArray.push(storageData);
        }

        if (!targetCalendarId) targetCalendarId = this.getCurrentSelectedCalendar()?.ID;

        if (!targetCalendarId) return null;

        for (let savedSetting of storageData.calendars) {
            if (savedSetting.calendarId == targetCalendarId) {
                return savedSetting;
            }
        }

        return {
            calendarId: targetCalendarId,
            colors: [],
            autoAdjust: null,
            deselectedFilterIds: [],
            selectedFilterIds: [],
            selectedSubfilterIds: [],
            deselectedSubfilterIds: [],
            lastSetViewMode: null,
            showStartTime: null,
            showEndTime: null,
            showDataGroups: null,
            showEmptyGroups: null,
            showTimeIndicator: null,
            scaleFactor: 1,
            YearViewMonthsCount: 12,
            YearViewFirstMonth: 0
        };
    }

    private saveUserSettingsToStorage(data: userCalendarSettings) {
        if (!data || !data.calendarId) return;

        if (!this._enableLocalUserSettings) {
            return;
        }

        try {

            let storageDataArray = this._getUserSettingsArrayFromStorage();

            let key = location.origin + location.pathname;
            let storageData: lastUserSettings = null;

            // aus den kompletten Settings den Datensatz für das aktuelle Webtool und den aktuellen User suchen und rauswerfen:
            for (let i = 0; i < storageDataArray.length; i++) {
                let storage = storageDataArray[i];
                if (storage.id == key && storage.userId == this.getCurrentUserId()) {
                    storageData = storage;
                    storageDataArray.splice(i, 1);
                    break;
                }
            }

            //console.debug(this.id + " saveUserSettingsToStorage", "new: ", data, "current: ", storageData);

            if (!storageData) {
                storageData = {
                    id: key,
                    previousSelectedCalendarId: null,
                    calendars: [],
                    userId: this.getCurrentUserId()
                };
            }

            // aus den hinterlegten Kalendern der Settings den aktuellen rauswerfen:
            for (let i = 0; i < storageData.calendars.length; i++) {
                let userData = storageData.calendars[i];
                if (userData.calendarId == data.calendarId) {
                    storageData.calendars.splice(i, 1);
                    break;
                }
            }

            storageData.previousSelectedCalendarId = data.calendarId; // den aktuellen Kalender als previousSelected hinterlegen

            storageData.calendars.push(data);
            storageDataArray.push(storageData);

            let storageDataStr = JSON.stringify(storageDataArray);
            window.localStorageShim.setItem("ego_CalendarSettings", storageDataStr);
            if (window.msTeamsSimpleApi.isCurrentlyRunningInTeamsTab) {
                window.msTeamsSimpleApi.helperFn.stateSet("ego_CalendarSettings", storageDataStr);
            }
        } catch (ex) {
            console.warn(this.id + ": local settings could not be saved", ex, data);
        }
    }

    getCurrentSelectedCalendar(): WebcalendarTypes.WebCalendar_Config {
        if (this.userProperties) {
            return this.userProperties.currentCalendarConfig;
        }

        return null;
    }
    /**
     * Fügt einen neuen Container zur Sidebar hinzu. Wenn mobileIcon angegeben ist, wird der Container auch mobil verfügbar.
     * @param uniqueName
     * @param label
     * @param domElement
     * @param mobileIcon
     */
    addCustomPane(uniqueName: string, label: string, domElement: HTMLElement, mobileIcon?: string): void {
        if (uniqueName == null || uniqueName == "") return;

        let newContainer = this.UiModder.domConstruct.create("div",
            {
                "className": "",
                "innerHTML": "",
                "id": "cstmPane-" + uniqueName, // brauchma ggf. für addContentToPane für die Query
            }, this.customPanesContainer);

        let expandButton = this.UiModder.domConstruct.create("button",
            {
                "className": "mds-button-base hoverDark paneExpanderButton",
                "innerHTML": label
            }, newContainer);

        let contentNode = this.UiModder.domConstruct.create("div",
            {
                "className": "sidebar-div",
                "innerHTML": ""
            }, newContainer);

        let mobileButton = null;

        if (typeof (mobileIcon) == "string") {
            mobileButton = this.UiModder.domConstruct.create("button",
                {
                    "className": "w3-hide-large mds-button-base hoverDark round w3-large button-for-min WebCalendar_paneButtons_mobileView",
                    "innerHTML": "<i class='" + mobileIcon + "'></i>"
                }, this.paneButtons_mobileView_container);

            on(mobileButton, "mouseenter", lang.hitch(this, this._setSelectedMobileDiv, uniqueName));
        }

        on(expandButton, "click", lang.hitch(this, this._onClick_TogglePaneExpand));

        let pane: WebcalendarTypes.WebCalendar_Pane = this.getCustomPaneByName(uniqueName);
        if (pane != null) {
            this.removePane(uniqueName);
        }

        pane = {
            name: uniqueName,
            rootNode: newContainer,
            buttonNode: expandButton,
            contentNode: contentNode,
            mobileButtonNode: mobileButton
        };

        this.customPanes.push(pane);

        this.addNodeToPane(uniqueName, domElement);

        if (this.customPanes.length > 0) {
            this.UiModder.domClass.remove(this.customPanesContainer, "w3-hide");
        }
    }

    removePane(name: string) {
        let index = this.getCustomPaneIndexByName(name);
        let container = this.getPaneNodeByName(name);

        // prüfen ob custom! wenn custom dann destroy, ansonsten nur hide!
        if (this.isPaneCustom(name) && index != -1) {

            let pane = this.customPanes[index];
            this.UiModder.domConstruct.destroy(pane.rootNode);

            this.customPanes.splice(index, 1);
        } else {

            container = this.getPaneNodeByName(name, true);
            if (container != null) {
                this.UiModder.domClass.add(container, "w3-hide");
            }

            let button = this.getPaneNodeByName(name, "mobile");
            if (button != null) {
                this.disableNode(button);
            }
        }

        if (this.customPanes.length == 0) {
            this.UiModder.domClass.add(this.customPanesContainer, "w3-hide");
        }
    }

    addNodeToPane(uniquePaneName: string, domElement: HTMLElement) {

        let container = this.getPaneNodeByName(uniquePaneName, false);

        if (container == null) return;

        if (!this.isPaneCustom(uniquePaneName)) {
            this.showPane(<WebcalendarTypes.WebCalendar_DefaultPanes>uniquePaneName);

            switch (uniquePaneName) {
                case WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane:
                    this.colorationPaneHasCustomContent = true;
                    break;
                case WebcalendarTypes.WebCalendar_DefaultPanes.resourcesPane:
                    this.resourcesPaneHasCustomContent = true;
                    break;
                case WebcalendarTypes.WebCalendar_DefaultPanes.datePane:
                    this.datePaneHasCustomContent = true;
                    break;
                case WebcalendarTypes.WebCalendar_DefaultPanes.filterPane:
                    this.filterPaneHasCustomContent = true;
                    break;

                case WebcalendarTypes.WebCalendar_DefaultPanes.userPane:
                    this.userPaneHasCustomContent = true;
                    break;

                case WebcalendarTypes.WebCalendar_DefaultPanes.viewOptionsPane:
                    this.viewOptionsPaneHasCustomContent = true;
                    break;
            }
        }

        this.UiModder.domConstruct.place(domElement, container, "last");

    }

    private showPane(name: WebcalendarTypes.WebCalendar_DefaultPanes, bShow?: boolean) {
        let container = this.getPaneNodeByName(name);

        if (bShow === false) {
            this.removePane(name);
            return;
        }
        if (this.isPaneCustom(name)) {
            // die Custompane blendet sich eh selber ein oder aus wenn was drin ist...
        } else {
            container = this.getPaneNodeByName(name, true);
            this.UiModder.domClass.remove(container, "w3-hide");

            let button = this.getPaneNodeByName(name, "mobile");
            if (button != null) {
                this.disableNode(button, false);
            }
        }
    }

    private getPaneNodeByName(name: string, bGetPaneRootContainer?: boolean | "mobile"): HTMLElement {


        if (!this.isPaneCustom(name)) {

            let node: HTMLElement = null;

            if (bGetPaneRootContainer === true) {
                node = this[name] as HTMLElement;
            }
            else if (bGetPaneRootContainer == "mobile") {
                switch (name) {
                    case WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane:
                        node = this.btnMobileColoration;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.datePane:
                        node = this.btnMobileDate;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.resourcesPane:
                        node = this.btnMobileResources;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.filterPane:
                        node = this.btnMobileFilter;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.userPane:
                        node = this.btnMobileFilter;  //this.btnMobileUser;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.viewOptionsPane:
                        node = this.btnMobileViewOptions;
                        break;
                    case WebcalendarTypes.WebCalendar_DefaultPanes.yearViewPane:
                        node = this.btnMobileYearView;
                        break;

                    default: node = null;
                }
            }
            else {
                switch (name) {
                    case WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane:
                        node = this.colorationContainer;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.datePane:
                        node = this.dateContainer;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.resourcesPane:
                        node = this.resourcesContainer;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.filterPane:
                        node = this.filterContainer;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.userPane:
                        node = this.userContainer;
                        break;

                    case WebcalendarTypes.WebCalendar_DefaultPanes.viewOptionsPane:
                        node = this.viewOptionsContainer;
                        break;
                    case WebcalendarTypes.WebCalendar_DefaultPanes.yearViewPane:
                        node = this.yearViewContainer;
                        break;

                    default: node = null;
                }
            }

            //console.debug("webcalendar getPaneNodeByName default", name, bGetPaneRootContainer, node);

            return node;
        }

        let paneRootContainer: HTMLElement = document.getElementById("cstmPane-" + name);
        let panes = bGetPaneRootContainer === true ? [paneRootContainer] : paneRootContainer.getElementsByClassName("sidebar-div");

        //console.debug("webcalendar getPaneNodeByName custom", name, bGetPaneRootContainer, panes);

        if (panes.length == 0) return null;

        return panes[0] as HTMLElement;
    }

    private isPaneCustom(name: string): boolean {
        let index = this.getCustomPaneIndexByName(name);

        if (index != -1) return true;

        return false;
    }

    setIsDndEditingEnabled(bool: boolean): void {
        //    this.isDndEditingEnabled = bool;
        //    if (bool == true) {
        //        this.UiModder.domClass.remove(this.editingButtonsContainer, "w3-hide");
        //    } else {

        //        //this._onClick_undoAll_button();

        //        //this.UiModder.domClass.add(this.editingButtonsContainer, "w3-hide");

        //        //this._onClick_unlockEditing_Button();

        //    }
    }

    private _setupUserProperties(): void {
        if (this.userProperties != null) {
            this.userProperties.destroy();
            this.userProperties = null;
        }
        this.userProperties = new UserProperties();
        
        let storageData = this._getUserSettingsFromStorage();
        if (storageData) {
            if (storageData.previousSelectedCalendarId) {
                
                this.userProperties.setSelectedCalendarId(storageData.previousSelectedCalendarId);
            }
        }

        if (this.__userPropConfig != null) {

            if (this.__userPropConfig.customFunctionName) {
                this.userProperties.addRequestParam("customFunctionName", this.__userPropConfig.customFunctionName);
            }

            if (this.__userPropConfig.requestUrl) {
                this.userProperties.setRequestUrl(this.__userPropConfig.requestUrl);
            }

            if (this.__userPropConfig.requestParams) {
                for (let param of this.__userPropConfig.requestParams) {
                    this.userProperties.addRequestParam(param.name, param.value);
                }
            }
        }

        this.UiModder.domConstruct.place(this.userProperties.domNode, this.userContainer);

        this.userProperties.startup();
    }

    openDefaultDetailView(item: WebcalendarTypes.WebCalendarItemData_Default, bSuppressRequest: boolean = false): MdsLax<InstanceType<typeof _EntityViewMixin<any>>> { // TODO: dive into dojo for the Item Typings

        console.log(this.id + " openDefaultDetailView", item);

        let selectedCalendar = this.getCurrentSelectedCalendar();
        let calendarID = "";
        if (selectedCalendar) {
            calendarID = selectedCalendar.ID;
        }

        let data: WebcalendarTypes.WebcalendarItemRequestData = {
            CalendarConfigId: calendarID,
            selectedHtCalendarID: calendarID,
            ClassName: item.Classname,
            EntityId: item.id
        }


        let tmpHeading = this.translate("General_Loading");

        if (item.barview_text) {
            tmpHeading = item.barview_text;
        }

        if (this.itemView != null && !this.itemView._destroyed) {
            try {
                this.itemView.destroy();
            } catch (ex) {

            }

            this.itemView = null;
        }


        let classnameValue = item.Classname;
        for (let baseClass of item.BaseClasses) {
            if (baseClass === "vt_travel") classnameValue = "vt_travel";
        }

        switch (classnameValue) {
            case VAMclassNames.ev_booking:
                let evbview = new EvBookingView();
                evbview.setAdditionalRequestParameters(data);
                evbview.setContextName("webcalendar");
                evbview.showAsDlg(item.id, item.barview_text);

                evbview.on("change", lang.hitch(this, this._onEntityChanged, item));
                evbview.on("deleted", lang.hitch(this, this._onEntityDeleted, item));

                this.itemView = evbview as any;
                break;

            case VAMclassNames.ev_projects:
                let evpview = new ProjectView();
                evpview.setAdditionalRequestParameters(data);
                evpview.setContextName("webcalendar");
                evpview.showAsDlg(item.id, item.barview_text);

                evpview.on("change", lang.hitch(this, this._onEntityChanged, item));
                evpview.on("deleted", lang.hitch(this, this._onEntityDeleted, item));

                this.itemView = evpview;
                break;

            case PAclassNames.private_appointment:
                let paview = new PrivateAppointmentView();
                paview.setAdditionalRequestParameters(data);
                paview.setContextName("webcalendar");
                paview.showAsDlg(item.id, item.barview_text);

                paview.on("change", lang.hitch(this, this._onEntityChanged, item));
                paview.on("deleted", lang.hitch(this, this._onEntityDeleted, item));

                this.itemView = paview;
                break;
            case SaleClasses.PlanningObjectOperator:
                let pooView = new PlanningObjectOperatorView();

                pooView.setup(item.id, item.barview_text, data, "webcalender");

                pooView.on("change", lang.hitch(this, this._onEntityChanged, item));
                pooView.on("deleted", lang.hitch(this, this._onEntityDeleted, item));


                this.itemView = pooView;
                break;
            case VAMclassNames.vt_travel:
                let travelView = new TravelBookingView();
                travelView.setAdditionalRequestParameters(data);
                travelView.setContextName("webcalendar");

                travelView.setup(item.id, item.barview_text);

                travelView.on("change", lang.hitch(this, this._onEntityChanged, item));
                travelView.on("deleted", lang.hitch(this, this._onEntityDeleted, item));

                this.itemView = travelView;
                break;
            default:
                this.itemView = new GenericEntityView();

                (this.itemView as MdsLax<InstanceType<typeof GenericEntityView>>).setup(data.EntityId, data.ClassName, tmpHeading, null, null, data, "webcalendar");

                //this.itemView.on("closed", function () { alert("closed") });
                this.itemView.on("change", lang.hitch(this, this._onEntityChanged, item));
                this.itemView.on("deleted", lang.hitch(this, this._onEntityDeleted, item));

                break;
        }

        if (this.itemView) {
            this.emit("itemViewCreated", this.itemView);
        }

        return this.itemView;

    }

    private _onEntityChanged(item?: WebcalendarTypes.WebCalendarItemData_Default) {
        this.reloadData(item, 200);
    }

    private _onEntityDeleted() {
        this.loadDataOfRange_Delayed();
    }

    private _checkCreateAppointmentPrivilege(): void {
        this.hasUserRole(["EvBooking_Create", "EvBooking_Edit"], lang.hitch(this, this._showBookingEditorInterface));
    }

    private _checkCreatePrivateAppointmentPrivilege(): void {
        this.hasUserRole("PrivateAppointment_Handle", lang.hitch(this, this._showPrivateAppointmentInterface));
    }

    protected _loadGoogleSyncSettings(): void {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API_GoogleSync__GetSyncSettings", {}, lang.hitch(this, this._onLoadGoogleSyncSettingsResponse), lang.hitch(this, this._onLoadGoogleSyncSettingsError));
    }

    protected _onLoadGoogleSyncSettingsResponse(syncSettings: GoogleSyncSettings): void {
        this.StandbyStop();
        //debugger;
        this.toggleCb(this.cbShowGoogleAppointmentsInEvis, this.btnShowGoogleAppointmentsInEvis, syncSettings.ShowGoogleAppointmentsInEvis === true);
    }

    protected _onLoadGoogleSyncSettingsError(error): void {
        this.StandbyStop();
    }

    private _onChange_GoogleSyncSettings_Any(): void {
        this.toggleCb(this.cbShowGoogleAppointmentsInEvis, this.btnShowGoogleAppointmentsInEvis);

        let jsonData = {
            name: "ShowGoogleAppointmentsInEvis",
            value: this.cbShowGoogleAppointmentsInEvis.checked
        };

        this.RequestManager.callfunction("Webtool_API_GoogleSync__SetSingleSyncSetting", jsonData, lang.hitch(this, this._onSaveSyncSettingsResponse), lang.hitch(this, this._onSaveSyncSettingsError), true);
    }

    protected _onSaveSyncSettingsResponse(response: GoogleSyncSettings): void {
        this.StandbyStop();

        this.loadDataOfRange_Delayed();
    }

    protected _onSaveSyncSettingsError(err): void {
        this.StandbyStop();

        this.showToast(err.Message, toasterIcons.error);
    }

    private _onClick_ToggleEnableBookingCreation(value): void {
        if (value == true && this.enablePrivAppointmentCreation == true) this.enablePrivAppointmentCreationToggle.setValue(false);
        this.enableBookingCreation = value;
        this.UiModder.domClass.toggle(document.body, "createEventByClick", value);
    }
    private _onClick_ToggleEnablePrivAppointmentCreation(value): void {
        if (value == true && this.enableBookingCreation == true) this.enableBookingCreationToggle.setValue(false);
        this.enablePrivAppointmentCreation = value;
    }

    private _showPrivateAppointmentInterface(bool?: boolean): void {

        if (bool) {
            let container = this.UiModder.domConstruct.create("div", {
                className: "w3-section"
            });

            this.enablePrivAppointmentCreationToggle = new CheckBox();
            this.enablePrivAppointmentCreationToggle.set("type", "toggle");
            this.enablePrivAppointmentCreationToggle.on("change", lang.hitch(this, this._onClick_ToggleEnablePrivAppointmentCreation));
            this.enablePrivAppointmentCreationToggle.setLabel(this.translate("WebCalendar_SidebarPane_btnLabel_EnablePrivAppointmentCreation"));

            this.UiModder.domClass.add(this.enablePrivAppointmentCreationToggle.domNode, "w3-padding w3-medium");

            this.enablePrivAppointmentCreationToggle.placeAt(container);

            let createBookingBtn = new Button();
            createBookingBtn.setup({
                callback: lang.hitch(this, this._onclickOpenPrivAppointmentEditor, null, null),
                styleClass: "newBtn createAppointmentBtn",
                label: "WebCalendar_SidebarPane_btnLabel_createPrivateAppointment"
            }, container);


            if (this.getCustomPaneByName("appointmentPane")) {
                let line = this.UiModder.domConstruct.create("hr");
                this.addNodeToPane("appointmentPane", line);
                this.addNodeToPane("appointmentPane", container);
            } else {
                this.addCustomPane("appointmentPane", this.translations["WebCalendar_SidebarPane_paneLabel_appointmentPane"], container, "fas fa-calendar-plus");

            }
        }
    }

    private _showBookingEditorInterface(bool?: boolean): void {
        //console.log("_showBookingEditorInterface", bool);
        if (this.hasFeature("Webcalendar/DisableEvBookingEditor")) {
            bool = false;
        }
        this.bookingEditingEnabledForCurrentUser = bool === true;

        if (this.bookingEditingEnabledForCurrentUser == true) {
            let container = this.UiModder.domConstruct.create("div", {
                className: "w3-section"
            });

            this.enableBookingCreationToggle = new CheckBox();
            this.enableBookingCreationToggle.set("type", "toggle");
            this.enableBookingCreationToggle.on("change", lang.hitch(this, this._onClick_ToggleEnableBookingCreation));
            this.enableBookingCreationToggle.setLabel(this.translate("WebCalendar_SidebarPane_btnLabel_EnableBookingCreation"));

            this.UiModder.domClass.add(this.enableBookingCreationToggle.domNode, "w3-padding w3-medium");

            this.enableBookingCreationToggle.placeAt(container);

            let createBookingBtn = new Button();
            createBookingBtn.setup({
                callback: lang.hitch(this, this._onclickOpenBookingEditor, null, null),
                styleClass: "newBtn createBookingBtn",
                label: "WebCalendar_SidebarPane_btnLabel_createBooking"
            }, container);
            //this.UiModder.domConstruct.create("BUTTON", {
            //    innerHTML: icon.outerHTML + this.translations["WebCalendar_SidebarPane_btnLabel_createBooking"],
            //    className: "mds-button-base padding roundest accentBG hoverBright w3-medium",
            //    onclick: lang.hitch(this, this._onclickOpenBookingEditor, null, null)
            //}, container);


            if (this.getCustomPaneByName("appointmentPane")) {
                let line = this.UiModder.domConstruct.create("hr");
                this.addNodeToPane("appointmentPane", line);
                this.addNodeToPane("appointmentPane", container);
            } else {
                this.addCustomPane("appointmentPane", this.translations["WebCalendar_SidebarPane_paneLabel_appointmentPane"], container, "fas fa-calendar-plus");

            }
        } else {
            //this.removePane("evBookingEditorPane");
        }
    }

    private _onclickOpenPrivAppointmentEditor(item: WebcalendarTypes.WebCalendarItemData_Default, cellClickData: WebcalendarTypes.CellClickData_Simple = null): void {

        if (this.hasUserRole("PrivateAppointment_Handle")) {

            if (this.itemView && this.itemView._destroyed != true && (this.itemView as MdsLax<InstanceType<typeof _EntityViewMixin<any>>>).close) {
                try {

                    this.itemView.close();
                } catch (ex) {
                    // nich so schlümm
                }
            };


            if (this.currentPrivateAppointmentEditor != null) {
                if (this.currentPrivateAppointmentEditor._destroyed !== true) this.currentPrivateAppointmentEditor.destroy();
                this.currentPrivateAppointmentEditor = null;
            }

            this.currentPrivateAppointmentEditor = new PrivateAppointmentEditor();
            //this.currentBookingEditor.setEvBookingEditorConfig(this.evBookingEditorSectionsConfig);

            if (item && item.id) {
                this.currentPrivateAppointmentEditor.loadEntityById(item.id);
            } else {
                this.currentPrivateAppointmentEditor.startup();

                if (cellClickData != null) {
                    // standardwerte aus gewähltem Kalender-Segment falls über CellClick geöffnet wird
                    let start = cellClickData.startTime;
                    let end = cellClickData.endTime;

                    let duration = end.getTime() - start.getTime();
                    //console.log(duration);
                    if (duration == 86400000) { // wenn ganztags-Termin dann war es ein klick auf eine Monats-Zelle.
                        end = new Date(end.getTime() - 60 * 1000); // 1 minute abziehen
                    }

                    this._editorReadyHandle = this.currentPrivateAppointmentEditor.on("ready", lang.hitch(this, this._onPrivateAppointmentEditorReady, start, end, cellClickData.resource));

                }

                this.currentPrivateAppointmentEditor.setStartupState("ready");
            }

            this.currentPrivateAppointmentEditor.on("saved", lang.hitch(this, this._onItemUpdated));
        } else {
            alert("Current User has no permissions for peivate appointment editor")
        }
    }

    private _onclickOpenBookingEditor(item: WebcalendarTypes.WebCalendarItemData_Default, cellClickData: WebcalendarTypes.CellClickData_Simple = null): void {

        if (this.bookingEditingEnabledForCurrentUser == true) {

            if (this.itemView && this.itemView._destroyed != true && (this.itemView as MdsLax<InstanceType<typeof _EntityViewMixin<any>>>).close) {
                try {

                    this.itemView.close();
                } catch (ex) {
                    // nich so schlümm
                }
            };


            if (this.currentBookingEditor != null) {
                if (this.currentBookingEditor._destroyed !== true) this.currentBookingEditor.destroy();
                this.currentBookingEditor = null;
            }

            this.currentBookingEditor = new EvBookingEditor();
            //this.currentBookingEditor.setEvBookingEditorConfig(this.evBookingEditorSectionsConfig);

            if (item && item.id) {
                this.currentBookingEditor.loadEntityById(item.id);
            } else {
                this.currentBookingEditor.startup();

                if (cellClickData != null) {
                    // standardwerte aus gewähltem Kalender-Segment falls über CellClick geöffnet wird
                    let start = cellClickData.startTime;
                    let end = cellClickData.endTime;

                    let copyStart: Date;
                    let copyEnd: Date;

                    if (start && end) {

                        let duration = end.getTime() - start.getTime();
                        //console.log(duration);
                        if (duration == 86400000) { // wenn ganztags-Termin dann war es ein klick auf eine Monats-Zelle.
                            end = new Date(end.getTime() - 60 * 1000); // 1 minute abziehen
                        }

                        copyStart = new Date(start.valueOf());
                        copyEnd = new Date(end.valueOf());

                    }


                    this._editorReadyHandle = this.currentBookingEditor.on("ready", lang.hitch(this, this._onBookingEditorReady, copyStart, copyEnd, cellClickData.resource));
                }

                this.currentBookingEditor.setStartupState("ready");
            }
            //this.currentBookingEditor.startup();



            this.currentBookingEditor.on("saved", lang.hitch(this, this._onItemUpdated));
        } else {
            alert("Current User has no permissions for booking editor")
        }
    }

    private _onBookingEditorReady(start, end, resource: WebcalendarTypes.SyncfusionCalendarResource) {
        setTimeout(lang.hitch(this, this._presetBookingEditor, start, end, resource), 1);

        if (this._editorReadyHandle) {
            this._editorReadyHandle.remove();
            this._editorReadyHandle = null;
        }
    }

    private _presetBookingEditor(start, end, resource: WebcalendarTypes.SyncfusionCalendarResource) {
        this.currentBookingEditor.setAttributeValue("date_start", start);
        this.currentBookingEditor.setAttributeValue("date_end", end);

        if (resource) {
            // improvisiertes Raum-Objekt setzen. Toll ist das aber nicht, sobald das mal doch kein Raum ist, haben wir den Salat.
            if (resource.type == "ev_rooms") {
                this.currentBookingEditor.setAttributeValue("ref_ev_room", { ID: resource.id, gDisp_1: resource.label });
            }
            //this.currentBookingEditor.setAttributeValue("ref_ev_room.ID", cellClickData.resource.id );
        }
    }

    private _onPrivateAppointmentEditorReady(start, end, resource: WebcalendarTypes.SyncfusionCalendarResource) {
        setTimeout(lang.hitch(this, this._presetPrivateAppointmentEditor, start, end, resource), 1);

        if (this._editorReadyHandle) {
            this._editorReadyHandle.remove();
            this._editorReadyHandle = null;
        }
    }

    private _presetPrivateAppointmentEditor(start, end, resource: WebcalendarTypes.SyncfusionCalendarResource) {
        this.currentPrivateAppointmentEditor.setAttributeValue("date_start", start);
        this.currentPrivateAppointmentEditor.setAttributeValue("date_end", end);
    }


    private isJSON(text) {
        if (typeof text !== "string") {
            return false;
        }
        try {
            JSON.parse(text);
            return true;
        } catch (error) {
            return false;
        }
    }

    private _convertISODateStringToLocalDateString(isoDate: string): string {
        var sYear: string = isoDate.slice(0, 4);
        var sMonth: string = isoDate.slice(5, 7);
        var sDay: string = isoDate.slice(8, 10);
        var sHour: string = isoDate.slice(11, 13);
        var sMinute: string = isoDate.slice(14, 16);
        return `${sDay}.${sMonth}.${sYear}, ${sHour}:${sMinute}`;
    }

    publishToastMessage(text: string, icon: ToasterHelpers.ToasterIcons = ToasterHelpers.ToasterIcons.warning, timeout: number = 4000, extendedMessage?: string) {

        this.editToastUUID = function () {
            return "uuid-" + ((new Date).getTime().toString(16) + Math.floor(1E7 * Math.random()).toString(16));
        }

        this.UiModder.domStyle.set(this.toaster.domNode, "z-index", 100);

        let options: toastOptions = {
            timeout: timeout,
            closeButton: true,
            ID: this.editToastUUID()
        };

        if (extendedMessage != null && typeof (extendedMessage) != "undefined") {
            options.onClick = {
                callback: lang.hitch(this, this.showErrorDetailsDlg, extendedMessage, text, null, "close", null)
            };

        }

        this.toaster.addToast(text, icon, options);
    }

    private showErrorDetailsDlg(message, header, subtitle, buttons, callback) {
        let dlg = new GenericDialog();
        dlg.show(message, header, subtitle, null, buttons, callback);
    }

    private __userPropConfig: WebcalendarTypes.WebCalendarUserPropertiesConfig = {
        customFunctionName: "Webtool_API_Webcalendar__GetUserProperties"
    };

    private _onItemUpdated(response: any): void {
        if (typeof (response) == "undefined") response = "success";

        topic.publish("mainProperties/enableCalButtons");

        this.itemEditChangesRegistry = [];
        //this.loadCalendarData(this.calendar._timeInterval[0], this.calendar._timeInterval[1]); // this.dateStart, this.dateEnd);
        this.loadDataOfRange_Delayed();

    }
    private _loadTimeoutHandle: any = null;
    private _loadExtTimeoutHandle: any = null;

    private _loadCalendarData(params: { start: Date, end: Date, callbackData?: any, targetItem?: WebcalendarTypes.WebCalendarItemData_Default }): void {

        //this.StandbyStart(this.calendar.viewContainer); // kaputt?? warum? - RJ 2023-01-31
        //this.StandbyStart(document.getElementById("mainContent")); // nicht ideal, weil nicht zentriert wenn Sidebar sichtbar. aber bitte.
        if (this.userProperties.currentCalendarConfig == null) {
            return;
        }

        this._previousResultPart = null;

        var pStart: Date = params.start;
        var pEnd: Date = params.end;

        //// letztgültige werte abspeichern
        //this.dateStart = pStart;
        //this.dateEnd = pEnd;

        //  zeitzonenoffset ausgleichen
        //
        if (params.start.getTimezoneOffset() < 0) {
            pStart = date.add(params.start, "minute", params.start.getTimezoneOffset() * (-1));
            pEnd = date.add(params.end, "minute", params.end.getTimezoneOffset() * (-1));
        }

        if (this._loadTimeoutHandle) clearTimeout(this._loadTimeoutHandle);
        if (this._loadExtTimeoutHandle) clearTimeout(this._loadExtTimeoutHandle);

        if (this._getFilterDataRequest != null && this._getFilterDataRequest.cancel) {
            this._getFilterDataRequest.cancel();
            this._getFilterDataRequest = null;
        }

        if (this.viewBehaviour == "listview") {
            if (this._currentRequestParams && params.targetItem) {
            } else {
                this.StandbyStart(this.listView_container, "listview"); // standby nur starten, wenn nicht einzel-update
            }
        }

        let stampOptions: object = {
            milliseconds: true,
            zulu: true
        };

        this.syncFusionCalendar.tooltipAdditionalOptions = Object.assign(this.syncFusionCalendar.tooltipAdditionalOptions, {
            resourcesConfigCalenderId: this.userProperties.currentCalendarConfig.ref_web_calendar.ID, // LEGACY - ablösen durch calendarID!
            calendarID: this.userProperties.currentCalendarConfig.ref_web_calendar.ID
        });


        this._currentRequestParams = {
            _version: 202506,
            start: stamp.toISOString(pStart, stampOptions),
            end: stamp.toISOString(pEnd, stampOptions),
            filters: this.getActiveFilterIDs(),
            subfilters: this.getActiveSubfilterIDs(),
            cid: this.userProperties.currentCalendarConfig.ID,
            mode: this.viewBehaviour == "timeline" ? "timeline" : this.calendarInterval, // LEGACY!
            viewBehaviour: this.viewBehaviour,
            viewType: this.viewBehaviour == "timeline" ? "timeline" : this.calendarInterval,
            viewMode: this.viewBehaviour == "listview" ? WebcalendarTypes.WebCalendar_ViewModes.listView : this.syncFusionCalendar.getCurrentViewMode(),
            limit: this.__requestItemLimit > 5 ? this.__requestItemLimit : 999
            //steps: this.calendarIntervalSteps
        };

        if (params.targetItem) {
            this._currentRequestParams.targetAppointmentClass = params.targetItem.Classname;
            this._currentRequestParams.targetAppointmentID = params.targetItem.id;
        }

        console.trace("_loadCalendarData", this._currentRequestParams);

        this._loadTimeoutHandle = setTimeout(lang.hitch(this, this._getFilterData, params), 666); // durch die Animation der Oberfläche wirkt die Verzögerung ok - sonst zu viele Requests beim Blättern!

        this.disableNode(this.autoAdjust_container, this.calendarInterval == WebcalendarTypes.WebCalendar_ViewTypes.month ||
            this.viewBehaviour == "timeline");
        this.disableNode(this.calendarZoomContainer, this.calendarInterval == WebcalendarTypes.WebCalendar_ViewTypes.month &&
            this.viewBehaviour != "timeline");

        this.hideNode(this.showTimeIndicator_container, this.calendarInterval == WebcalendarTypes.WebCalendar_ViewTypes.month);

    }

    private _onSetScheduleEventsComplete(eventArgs: { callback: Function, scope: object }) {

        if (this.hasFeature("User/GoogleSyncManager")) {

            let syncSettings = window.sessionInfo.getGoogleSyncSettings();
            if (syncSettings?.ShowGoogleAppointmentsInEvis == true) {

                this._loadExtTimeoutHandle = setTimeout(
                    lang.hitch(
                        this,
                        this._loadExternalCalendarData,
                        lang.hitch(eventArgs.scope, eventArgs.callback)
                    ),
                    100);
            }
        }
    }

    private toStringISO(date: Date): string {

        return date.toISOString();
    }

    private _loadExternalCalendarData(callbackExternalData) {


        let jsonData = {
            start: this._currentRequestParams.start,
            end: this._currentRequestParams.end
        };


        this.RequestManager.callfunction("Webtool_API_GetExternalCalendarData", jsonData, lang.hitch(this, this._loadExternalCalendarDataResponse, callbackExternalData), lang.hitch(this, this._loadExternalCalendarDataError));
    }

    private _loadExternalCalendarDataResponse(callbackExternalData: Function, response: Array<SyncFusionCalendarTypes.Syncfusion_EventItem<WebcalendarTypes.WebCalendarItemData_Default>>) {
        console.log("Webtool_API_GetExternalCalendarData", response);

        // DIESE FUNKTION ENTHÄLT BEREITS DEN PASENDEN SCOPE!
        //  NICHT hitchen!
        callbackExternalData(response); // rückmeldung an SyncFusionCalendar ausgehend von emit "setScheduleEventsComplete"
    }

    private _loadExternalCalendarDataError(error) {

    }
    private _previousResultPart: FilterresultData;
    private _currentRequestParams: WebcalendarTypes.RequestData;
    private _getFilterData(args?: { callbackData?: any, targetItem?: WebcalendarTypes.WebCalendarItemData_Default }): void {
        this.emit("loading");

        let label = this.currentPreConfig?.dataLoadingLabel;

        if (this.viewBehaviour == "listview") {

        } else {
            if (typeof (this._currentRequestParams.startIndex) != "number") {

                // falls nur ein item geladen wird, nicht alles mit standby blockieren?
                if (args?.targetItem) {
                    //    let nodes = this.syncFusionCalendar.getItemNodes(args.targetItem.id);
                    //    if (nodes?.length == 1) {
                    //        this.
                    //    }
                    
                } else {
                    this.syncFusionCalendar.showLoadingScreen("Events");
                }
            }
        }

        let params = this._currentRequestParams;

        if (this.viewBehaviour == "timeline") {
            params.resources = this.getSelectedResourceGroups();
        }



        //if (params.mode == "month" && this.calendarIntervalSteps == 1) {
        //    params.start = stamp.toISOString(date.add(pStart, "week", -1), stampOptions);
        //    params.end = stamp.toISOString(date.add(pEnd, "week", 1), stampOptions);
        //}


        if (this._getFilterDataRequest != null && this._getFilterDataRequest.cancel) {
            this._getFilterDataRequest.cancel();
            this._getFilterDataRequest = null;
        }

        this._currentRequestParams = params;


        if (this.__filterDataAdditionArgs) {
            this._currentRequestParams.additionalGetFilterDataParameters = this.__filterDataAdditionArgs;
        } else {
            this._currentRequestParams.additionalGetFilterDataParameters = {};
        }

        let callbackData = null;
        if (args) {
            callbackData = args.callbackData;
        }

        this._getFilterDataRequest = this.RequestManager.callfunction(
            this.__filterDataFunction,
            this._currentRequestParams,
            lang.hitch(this, this._onGetFilterData_Response, callbackData),
            lang.hitch(this, this._onGetFilterData_Error)
        );


    }

    private _onGetResourcesData_Response(response: any) {
        this._getResourcesDataRequest = null;
        let resourcesDataResponse: Array<WebcalendarTypes.WebCalendarResourceData<any>>;


        if (this.isJSON(response)) {
            resourcesDataResponse = JSON.parse(response);
        } else if (response.Exception == true) {
            alert("ERROR loading filterData: details in the console")
            console.error(response);
            return;
        } else {
            resourcesDataResponse = response;
        }

        this._lastLoadedResources = resourcesDataResponse;

        this.drawResources(response);
    }
    private drawResources(resources: Array<WebcalendarTypes.WebCalendarResourceData<any>>) {
        this.UiModder.domConstruct.empty(this.resourcesTogglesContainer);

        this.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.resourcesPane);

        if (resources.length > 0) {
            if (this.syncFusionCalendar.isTimeLineMode()) {
                this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.resourcesPane);
            }
            //domClass.remove(this.resourcesPane, 'w3-hide');
        } else {
            this.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.resourcesPane);

            return;
        }

        for (let i = 0; i < resources.length; i += 1) {
            const resource: WebcalendarTypes.WebCalendarResourceData<any> = resources[i];

            const registryEntry: WebcalendarTypes.WebCalendarResourceCheckboxes = {
                checkbox: null, //checkbox,
                button: null, //button,
                label: null,//label,
                resourceData: resource,
                selected: resource.is_active
            };

            const cbContainer: HTMLElement = domConstruct.create("div", {
                style: {
                    marginBottom: "3px",
                    paddingBottom: "1px"
                },
            }, this.resourcesTogglesContainer);

            const checkbox: HTMLInputElement = domConstruct.create("input", {
                type: "checkbox",
                class: "w3-check w3-hide",
                value: resource.name,
                checked: resource.is_active == true,
                id: "resourceCheckbox_" + this.resourceGroupRegistry.length
            }, cbContainer, "last") as HTMLInputElement;

            const button: HTMLButtonElement = domConstruct.create("button", {
                className: "mds-button-base hoverBright round w3-block filterButton",
                innerHTML: resource.title
            }, cbContainer) as HTMLButtonElement;
            if (!this.syncFusionCalendar.isTimeLineMode()) this.disableNode(button);

            domClass.toggle(button, "active", resource.is_active == true);


            let clickEvent = lang.hitch(this, this._onClick_ToggleResourceGroup, registryEntry);
            on(button, "click", clickEvent);

            const label: HTMLElement = domConstruct.create("label",
                {
                    "innerHTML": resource.title,
                    "className": "filterLabel w3-hide",
                    "for": checkbox.id,
                    style: {
                        //"color": htFilter.ref_web_calendar_filter.coloration ? htFilter.ref_web_calendar_filter.coloration.BackColor.Hex : ""
                    }
                }, cbContainer);

            if (resource.coloration) {
                let bgColor = ColorHelpers.getHexColorFromProperty(resource.coloration, "BG");
                let txtColor = ColorHelpers.getHexColorFromProperty(resource.coloration, "TXT");

                button.style.setProperty("--filterColor", bgColor);
            }

            registryEntry.button = button;
            registryEntry.checkbox = checkbox;
            registryEntry.label = label;

            this.resourceGroupRegistry.push(registryEntry);
        }

        if (this.viewBehaviour == "timeline") {
            this.switchViewmode(this.calendarButtons.getSelectedViewMode());
        }
    }
    private _onGetResourcesData_Error(err): void {
        this._getResourcesDataRequest = null;
        alert(err.Message);
        console.error("get resources failed: " + err);
        this.StandbyStop();
    }

    private _splitAlldayEvents(items: Array<WebcalendarTypes.WebCalendarItemData_Default>): Array<WebcalendarTypes.WebCalendarItemData_Default> {
        let newItems = [];
        for (let item of items) {

            let startDate = new Date(item.startTime);
            let endDate = new Date(item.endTime);

            if (startDate.getDate() != endDate.getDate()) {
                let currentStart = new Date(item.startTime);
                let currentEnd = new Date(item.startTime);

                let copy = item;

                for (let i = 0; currentEnd.valueOf() < endDate.valueOf(); i++) {
                    copy = lang.clone(copy);

                    if (i == 1) {
                        currentStart.setHours(0, 0, 0); // ab dem ersten durchlauf auf tagesanfang setzen.
                    }

                    currentEnd.setHours(23, 59, 59);
                    if (currentEnd.valueOf() > endDate.valueOf()) {
                        currentEnd = endDate;

                    }

                    copy.startTime = this.dateToLocalISOString(currentStart);
                    copy.endTime = this.dateToLocalISOString(currentEnd);

                    currentStart.setDate(currentStart.getDate() + 1);
                    currentEnd = new Date(currentStart.valueOf());

                    newItems.push(copy);

                }

            } else {
                if (item.allDay == true) {
                    item.allDay = false;

                    startDate.setHours(0, 0, 0, 0);
                    endDate.setHours(23, 59, 59);

                    item.startTime = this.dateToLocalISOString(startDate);
                    item.endTime = this.dateToLocalISOString(endDate);
                }

                newItems.push(item);
            }
        }

        return newItems;
    }

    private progressbar: MdsLax<InstanceType<typeof ProgressBar>>;

    private _previousHolidaysResponse: Array<WebcalendarTypes.Holiday>;
    private _onGetFilterData_Response(callbackData: any, _anyResponse: any) {


        this._getFilterDataRequest = null;

        if (this._loadCalendarDataCallback != null) {
            this._loadCalendarDataCallback();
        }

        let filterDataResponse: FilterresultData;

        if (this.isJSON(_anyResponse)) {
            filterDataResponse = JSON.parse(_anyResponse);
        } else if (_anyResponse.Exception == true) {
            alert("ERROR loading filterData: details in the console")
            console.error("ERROR loading filterData", _anyResponse);
            return;
        } else {
            filterDataResponse = _anyResponse;
        }

        // einzelnes Result?
        if (filterDataResponse.singleItemUpdate) {
            if (filterDataResponse.items.length == 1) {
                if (this.viewBehaviour == "calendar" || this.viewBehaviour == "timeline") {
                    this.syncFusionCalendar.updateEvent(filterDataResponse.items[0])
                }
                else if (this.viewBehaviour == "listview") {
                    this.listView.updateItem(filterDataResponse.items[0]);
                }
            }
            return;
        }

        // gabs davor schon ein Teilergebnis?
        if (this._previousResultPart == null) {
            this._previousResultPart = filterDataResponse.items ? filterDataResponse : null;
        } else {
            this._previousResultPart.items = this._previousResultPart.items.concat(filterDataResponse.items);
        }

        // dynamisches Requestlimit, falls itemCount das Limit überschreitet und in Stücken abgefragt werden soll:
        let dynlimit = this.__requestItemLimit;
        let steps = 1;
        let completeCount = filterDataResponse.items?.length;
        if (filterDataResponse.itemCount) {
            completeCount = filterDataResponse.itemCount;
            steps = Math.ceil(completeCount / dynlimit); // bei 1400 zb 3,xxx => 4 Steps; bei 100 = 0,25 => 1 step
            if (!steps || steps < 1) steps = 1; // Sicherheitshalber
            dynlimit = Math.ceil(completeCount / steps);
        }

        if (filterDataResponse.holidays) {
            this._previousHolidaysResponse = filterDataResponse.holidays;
        }

        if (this._currentRequestParams.requestID != filterDataResponse.requestID) {
            this._currentRequestParams.requestID = filterDataResponse.requestID



            // wenn wir hier stehen, hat sich die requestID zum ersten mal nach dem ursprünglichen Request auf einen Wert geändert
            // die Antwort vom Backend ist: Filterung ist durch, aber es sind so viele Ergebnisse
            // bitte scheibchenweise abholen
            if (this._currentRequestParams.requestID) {

                this._currentRequestParams.limit = dynlimit;
                if (typeof (filterDataResponse.nextIndex) != "number") filterDataResponse.nextIndex = 0;

                //for (let index = 0; index < completeCount; index = index + limit) {
                //    this.syncFusionCalendar.showLoadingScreen(index.toString(), index.toString());

                //}

                this.progressbar = new ProgressBar({
                    displayType: "modal",
                    heading: StringHelpers.stringFormat(TranslationHelpers.translate("WebCalendar__Progressbar_Titlebar"), completeCount.toString()),
                    initialText: "1 - " + dynlimit.toString(),
                    textlinesCount: Math.min(6, steps),
                    destroyAfterCompletion: true,
                    allowCancel: true,
                    noResponseTimeout: 25 * 1000
                });

                this.progressbar.on("cancel", lang.hitch(this, this._onCancel_Progressbar));
                this.progressbar.on("closed", lang.hitch(this, this._onClose_Progressbar));
            }
        }

        //if (typeof (filterDataResponse.startIndex) == "number") {
        //    this.syncFusionCalendar.hideLoadingScreen(filterDataResponse.startIndex.toString());
        //}

        if (typeof (filterDataResponse.nextIndex) == "number") {
            // es gibt noch mehr zu laden!
            this._currentRequestParams.startIndex = filterDataResponse.nextIndex;
            this._getFilterData({ callbackData: callbackData });

            if (this.progressbar) {
                let pct = filterDataResponse.nextIndex * 100 / completeCount;

                this.progressbar.setNewTarget(Math.min(pct, 99), (filterDataResponse.nextIndex + 1).toString() + " - " + Math.min(completeCount, (filterDataResponse.nextIndex + dynlimit)).toString());
            }

            return;
        } else {
            // zusammengefasste Teilergebnisse übernehmen:
            if (this._previousResultPart) {
                filterDataResponse = this._previousResultPart;
                this._previousResultPart = null;
            }
        }

        this.data = filterDataResponse;
        //this.lastGetFilterDataReponse = JSON.stringify(this.data);

        if (this.progressbar) {
            this.progressbar.setNewTarget(99, TranslationHelpers.tryTranslate("General_Finalising", false, null));

        }

        let groupingAvailable = true;
        if (typeof (this.selectedCalendarConfig?.ref_web_calendar?.bDataGroupingAvailable) == "boolean") {
            groupingAvailable = this.selectedCalendarConfig.ref_web_calendar.bDataGroupingAvailable;
        }

        // Gruppierung asblenden, wenn keine datengruppen vohanden sind
        groupingAvailable = groupingAvailable && filterDataResponse.DataGroupValues?.length > 0;

        // Gruppierung asblenden, wenn Timeline-Modus oder Jahreskalender
        groupingAvailable = groupingAvailable && this.viewBehaviour != "timeline" && this.calendarInterval != WebcalendarTypes.WebCalendar_ViewTypes.year;

        if (this.viewBehaviour == "listview") {

        } else {
            let currentCalendarConfig = this.getCurrentSelectedCalendar();
            if (currentCalendarConfig.b_show_allday_events_with_full_hours == true
                && !this.syncFusionCalendar.isTimeLineMode()) {
                let newList = this._splitAlldayEvents(filterDataResponse.items);

                filterDataResponse.items = newList;
            }
        }


        this.hideNode(this.data_grouping_container, !groupingAvailable);


        this.baseStore = new Memory({ data: filterDataResponse });

        this.store = new Observable(this.baseStore);

        //console.log("store::: ", this.store.data)


        //if (this.calendar.currentView.domNode.classList[0] == "dojoxCalendarColumnView") this.calendar.columnView.invalidateRendering();
        //this.calendar.set("store", this.store);

        let appointmentDates: Array<Date> = [];// filterDataResponse.items.map(item => new Date(item.startTime));
        /* funktioniert technisch! Problem: wenn weniger als der ganze Monat geladen ist, vermittelt das optisch falsche Info
        * braucht also einen eigenen Request für reine "besetzt"-Datumswerte, wär besser...
        */
        //for (let item of filterDataResponse.items) {
        //    let start = new Date(item.startTime);
        //    let end = new Date(item.endTime);
        //    start.setHours(0, 0, 0, 0);

        //    while (start.valueOf() < end.valueOf()) {
        //        appointmentDates.push(start);

        //        start = new Date(start.valueOf());
        //        start.setDate(start.getDate() + 1);
        //    }
        //}

        //this.datePicker.setAppointmentDates(appointmentDates);

        if (this.viewBehaviour == "listview") {
            let targetDate = this.listView.getCurrentScrollDate();

            this.listView.setAvailableGroupingValues(filterDataResponse.DataGroupValues);

            // es kann sein, dass für die Listview mehrere Monate gleichzeitig laden und jetzt daherkommen
            // deshalb die Items auseinanderklauben...
            for (let date of callbackData) {
                let monthDate = new Date(date.valueOf());
                monthDate.setDate(1);
                monthDate.setHours(0, 0, 0, 0);

                let monthValueMin = monthDate.valueOf();

                monthDate.setMonth(monthDate.getMonth() + 1);
                monthDate.setDate(monthDate.getDate() - 1);
                monthDate.setHours(23, 59, 59, 999);

                let monthValueMax = monthDate.valueOf();

                let results = [];
                for (let item of filterDataResponse.items) {
                    // item hat start und Ende. die Values auf Überschneidung mit der Monats-Basevalue prüfen
                    let minValue = new Date(item.startTime).valueOf();
                    let maxValue = new Date(item.endTime).valueOf();

                    if (monthValueMin <= maxValue && monthValueMax >= minValue) {
                        results.push(item);
                    }
                }
                this.listView.setHolidays(this._previousHolidaysResponse, date);
                this.listView.setItemResponse(results, date);
            }

            if (targetDate) this.listView.goToDate(targetDate, false);

        } else {
            if (this.hasFeature("webcalendar/displayHolidays")) {
                this.syncFusionCalendar.setHolidays(this._previousHolidaysResponse);
            }

            this.syncFusionCalendar.setScheduleEvents(this.data);

            setTimeout(lang.hitch(this, function () {
                //this.onChange_enableDatagrouping();
                //this.onChange_showEmptyGroups();

                if (this.viewBehaviour == "timeline") {

                } else if (this.viewBehaviour == "listview") {
                    //this.listView.showGroups(true);
                }
                else if (this.viewBehaviour == "calendar") {
                    if (groupingAvailable) {
                        // leere Gruppen auch anzeigen?
                        if (this.cbShowEmptyGroups.checked) {
                            this.syncFusionCalendar.showAllGroups(true);
                        } else {
                            this.syncFusionCalendar.showGroups(this.cbEnableDatagrouping.checked);
                        }
                    } else {
                        this.syncFusionCalendar.showGroups(false);
                    }
                }
                this.syncFusionCalendar.showTimeIndicator(this.cbShowTimeIndicator.checked);

            }), 40);

            //if (this.viewBehaviour == "calendar" && this.syncFusionCalendar.getCurrentViewMode() != WebcalendarTypes.WebCalendar_ViewModes.month) {
            //    setTimeout(lang.hitch(this.syncFusionCalendar, "scrollToFirstEvent"), 150);
            //}

        }


        this.StandbyStop();
        this.StandbyStop("listview");

        this.emit("loaded");

        if (this.progressbar) {
            this.progressbar.setNewTarget(100);

            this.progressbar = null;
        }

        this.UiModder.domClass.toggle(this.syncFusionCalendar.syncFusionContainer, "blur w3-disabled", false);
        this.UiModder.domClass.toggle(this.listView_container, "blur w3-disabled", false);

    }

    private _onGetFilterData_Error(err): void { // errorCallback

        this._getFilterDataRequest = null;

        if (this.progressbar) {
            this.progressbar.close();
            this.progressbar = null;
        }

        alert(err.Message);
        console.error(err);

        this.syncFusionCalendar.setScheduleEvents({ items: [], DataGroupValues: [] });
        this.StandbyStop();
        this.StandbyStop("listview");


        this.emit("loaded");
    }

    private _onCancel_Progressbar(args) {
        if (this._getFilterDataRequest && this._getFilterDataRequest.cancel) {
            this._getFilterDataRequest.cancel();
            this._getFilterDataRequest = null;
            this.syncFusionCalendar.setScheduleEvents({ items: [], DataGroupValues: [] });
            this.StandbyStop();
            this.StandbyStop("listview");

        }
    }
    private _onClose_Progressbar(args) {
        this.progressbar = null;

    }

    private _setSelectedMobileDiv(customName: string | MouseEvent, evt: MouseEvent): void {
        //console.log("_setSelectedMobileDiv: ", customName, evt)

        if (typeof (customName) == "string") {

        } else {
            evt = customName;
            customName = null;
        }

        // Alte auswahl entfernen
        var allDivs = query(".mobile-div-selected", this.divSidebar);
        allDivs.forEach(function (div) {
            domClass.remove(div, "mobile-div-selected");
        });

        let allMobileButtons = query(".button-for-min", this.divSidebar);
        allMobileButtons.forEach(function (div) {
            domClass.remove(div, "hover");
        });

        let selectedDivs;
        let sectionName: string;
        let hoveredButton: HTMLButtonElement = null;

        // Neue Auswahl hinzufügen
        if (customName) {
            let pane = this.getCustomPaneByName(<string>customName);
            if (pane) {
                //console.debug("_setSelectedMobileDiv - looking for custom pane", customName, pane);
                domClass.add(pane.mobileButtonNode, "hover");
                domClass.add(pane.contentNode, "mobile-div-selected");
            }
        }
        else if (evt && 'target' in evt) {
            if (domClass.contains(<HTMLElement>evt.target, "button-for-min")) {
                sectionName = (<HTMLElement>evt.target).dataset.section;
                hoveredButton = evt.target as HTMLButtonElement;
                domClass.add(hoveredButton, "hover");
            } else {
                sectionName = (<HTMLElement>evt.target).parentElement.dataset.section;
            }

            if (sectionName && this[sectionName]) {
                selectedDivs = query(".sidebar-div", <HTMLElement>this[sectionName]);

                if (selectedDivs) {
                    selectedDivs.forEach(function (div) {
                        domClass.add(div, "mobile-div-selected");
                    });
                }
            }

        } else {
            console.warn("'_setSelectedMobileDiv' invalid params??", evt, customName);
        }
    }

    private getCustomPaneByName(name: string): WebcalendarTypes.WebCalendar_Pane {

        let index = this.getCustomPaneIndexByName(name);

        if (index != -1) {
            return this.customPanes[index];
        }

        return null;
    }

    private getCustomPaneIndexByName(name: string): number {
        let index: number = 0;
        for (let pane of this.customPanes) {
            if (pane.name == name) {
                return index;
            }

            index++;
        }

        return -1;
    }
    private _onClick_TogglePaneExpand(evt: MouseEvent) {
        let button = evt.target as HTMLElement;
        this._toggleSidebarSection(button.parentElement);
    }
    private _toggleSidebarSection(node: HTMLElement, condition?: boolean): void {
        let contents: dojo.NodeList<HTMLElement>;
        let button: HTMLButtonElement;
        let paneRootNode: HTMLElement;
        //console.debug("_toggleSidebarSection", node, condition);


        if ('target' in node) { // legacy falls das html noch direkt das Klickevent auf diese Methode hat
            button = <HTMLButtonElement>node["target"];
            contents = query(".sidebar-div", button.parentElement);

            paneRootNode = node['target'] as HTMLElement;

            if (contents == null || !contents.length) { // das ist null wenn man beim Aufklappen auf das Symbol (i-node) geklickt hat. dann muss man noch eine Ebene höher
                if (button) button = <HTMLButtonElement>button.parentElement;
                contents = query(".sidebar-div", button.parentElement);
            }
        } else {
            paneRootNode = node as HTMLElement;

            button = <HTMLButtonElement>query(".button-for-max", <HTMLElement>node)[0];
            //if (!button) button = <HTMLButtonElement>query(".paneExpanderButton", <HTMLElement>node)[0];
            contents = query(".sidebar-div", <HTMLElement>node);
        }

        if (typeof (condition) == "undefined") {
            condition = !domClass.contains(paneRootNode, "expanded");
        }


        if (contents && contents.length) {
            for (let i = 0; i < contents.length; i++) {
                let content = contents[i];// as HTMLElement;
                domClass.toggle(content, "show-item-div", condition);
            }
        }

        domClass.toggle(paneRootNode, "expanded", condition);
        if (button) {
            domClass.toggle(button, "button-selected", condition);

            if (domClass.contains(button, "button-selected")) {
                var arrows = query(".fa-angle-right", button);
            } else {
                var arrows = query(".fa-angle-down", button);
            }

            for (var i = 0; i < arrows.length; i++) {
                var arrow = arrows[i];

                if (domClass.contains(button, "button-selected")) {
                    domClass.remove(arrow, "fa-angle-right");
                    domClass.add(arrow, "fa-angle-down");
                } else {
                    domClass.remove(arrow, "fa-angle-down");
                    domClass.add(arrow, "fa-angle-right");
                }
            }
        }
        if (contents.length) {
            if (this.UiModder.domClass.contains(contents[0], "show-item-div")) {
                contents[0].parentElement.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                });
            }
        }

    }

    private toggleCb(targetCb: HTMLInputElement, targetBtn: HTMLButtonElement, targetState?: boolean, disableBtn?: boolean): boolean {

        let hasChanged = false;

        if (typeof targetState == "boolean") {
            hasChanged = targetCb.checked != targetState;
            targetCb.checked = targetState;
        } else {
            targetCb.checked = !targetCb.checked;
            hasChanged = true;
        }

        let icon = this.createFontawesomeIcon("toggle", "&nbsp;&nbsp;");
        this.UiModder.domClass.toggle(targetBtn, "selected", targetCb.checked);
        this.UiModder.domClass.toggle(targetBtn, "deselected", !targetCb.checked);
        //this.UiModder.domClass.toggle(targetBtn, "sL4", !targetCb.checked);
        this.UiModder.domClass.toggle(icon, "fas fa-check-circle", targetCb.checked);
        this.UiModder.domClass.toggle(icon, "far fa-circle", !targetCb.checked);

        this.disableNode(targetBtn, disableBtn === true);

        this.UiModder.domConstruct.place(icon, targetBtn.firstElementChild, "only");

        return hasChanged;
    }

    private _onClick_autoAdjust(): void {
        if (this.toggleCb(this.cbAutoAdjust, this.btnAutoAdjust) == true) {
            this.onChange_autoAdjust();
        }
    }
    private onChange_autoAdjust(): void {
        //this.calendar.setAutoAdjust(this.cbAutoAdjust.checked);

        this.syncFusionCalendar.adjustSchedulerHeight(this.cbAutoAdjust.checked);

        let setting = this.getUserCalendarSettingsFromStore();
        setting.autoAdjust = this.cbAutoAdjust.checked;
        this.saveUserSettingsToStorage(setting);
    }

    private _onClick_enableDatagrouping(): void {
        this.showDataGroups(!this.cbEnableDatagrouping.checked);
    }

    private onChange_enableDatagrouping(): void {
        let value = this.cbEnableDatagrouping.checked;
        let value2 = this.cbShowEmptyGroups.checked;

        //this.calendar.showSubColumns(value || value2, this.cbShowEmptyGroups.checked)
    }

    private _onClick_showEmptyGroups(): void {

        this.showEmptyDataGroups(!this.cbShowEmptyGroups.checked);
    }

    private onChange_showEmptyGroups(): void {
        let value = this.cbEnableDatagrouping.checked;
        let value2 = this.cbShowEmptyGroups.checked;

        //this.calendar.showSubColumns(value || value2, this.cbShowEmptyGroups.checked)
    }

    private _onClick_showTimeIndicator(): void {

        this.toggleCb(this.cbShowTimeIndicator, this.btnShowTimeIndicator);

        this.onChange_showTimeIndicator();
    }

    private onChange_showTimeIndicator(): void {
        try {
            let userData: userCalendarSettings = this.getUserCalendarSettingsFromStore();
            userData.showTimeIndicator = this.cbShowTimeIndicator.checked;
            this.saveUserSettingsToStorage(userData);
        } catch (ex) {
            // dann wirds halt nicht gespeichert, ja mei.
        }

        this.setShowTimeIndicator(this.cbShowTimeIndicator.checked);
    }

    setShowTimeIndicator(bool?: boolean, skipRendering?: boolean): void {
        //this.calendar.showTimeIndicator(bool);
        this.toggleCb(this.cbShowTimeIndicator, this.btnShowTimeIndicator, bool);

        if (this.syncFusionCalendar){
            this.syncFusionCalendar.showTimeIndicator(bool);
        }
        this.listView?.showTimeIndicator(bool);
    }

    private _onClick_hideColumHeadIfNeeded(): void {

        this.toggleCb(this.cbHideColumHeadIfNeeded, this.btnHideColumHeadIfNeeded);

        this.onChange_hideColumHeadIfNeeded();
    }

    private onChange_hideColumHeadIfNeeded(): void {
        this.setHideColumHeadIfNeeded(this.cbHideColumHeadIfNeeded.checked);
    }

    setHideColumHeadIfNeeded(bool?: boolean, skipItemRendering?: boolean): void {
        //this.calendar.setHideColumHeadIfNeeded(bool);
    }
    private _onClick_showEndTime(): void {

        this.toggleCb(this.cbShowEndTime, this.btnShowEndTime);

        this.onChange_showEndTime();
    }
    private onChange_showEndTime(): void {
        this.setShowEndTime(this.cbShowEndTime.checked);

        try {
            let userSettings = this.getUserCalendarSettingsFromStore();
            userSettings.showEndTime = this.cbShowEndTime.checked;
            this.saveUserSettingsToStorage(userSettings);
        } catch (ext) {

        }
    }

    setShowEndTime(bool?: boolean): void {
        if (bool === true || bool == false) {
            this.__displaySettings.b_show_end_time = bool;
            //this.cbShowEndTime.checked = bool;
            this.toggleCb(this.cbShowEndTime, this.btnShowEndTime, bool);
            this.syncFusionCalendar?.showEndTime(bool);
            this.listView?.showEndTime(bool);
        }

    }
    private _onClick_showStartTime(): void {
        this.toggleCb(this.cbShowStartTime, this.btnShowStartTime);

        this.onChange_showStartTime();
    }
    private onChange_showStartTime(): void {
        this.setShowStartTime(this.cbShowStartTime.checked);

        try {
            let userSettings = this.getUserCalendarSettingsFromStore();
            userSettings.showStartTime = this.cbShowStartTime.checked;
            this.saveUserSettingsToStorage(userSettings);
        } catch (ext) {

        }
    }
    setShowStartTime(bool?: boolean): void {
        if (bool === true || bool == false) {
            this.__displaySettings.b_show_start_time = bool;
            //this.cbShowEndTime.checked = bool;
            this.toggleCb(this.cbShowStartTime, this.btnShowStartTime, bool);
            this.syncFusionCalendar?.showStartTime(bool);
            this.listView?.showStartTime(bool);
        }

    }


    private async _createCalendar() {

        this._toggleSidebarSection(this.datePane, true);

        this.UiModder.domClass.add(this.calendarView_container, "hidden w3-hide");
        this.UiModder.domClass.add(this.listView_container, "hidden w3-hide");

        // SYNCFUSION:
        let syncFusionCalendar = new SyncFusionCalendar();
        await syncFusionCalendar.initScheduler(this.calendarView_container);
        this.syncFusionCalendar = syncFusionCalendar;

        if (this.resourceClickFunction) syncFusionCalendar.setResourceClick(this.resourceClickFunction);
        syncFusionCalendar.setItemClickFunction(lang.hitch(this, this.itemClickFunction));
        syncFusionCalendar.getCurrentSelectedFilterIDs = lang.hitch(this, this.getActiveFilterIDs);
        syncFusionCalendar.setColumnView_bodyText_attribute("columnview_body_text");
        syncFusionCalendar.setColumnView_headText_attribute("columnview_head_text");
        this._setYearViewParameters();
        syncFusionCalendar.on("calendarCellClicked", lang.hitch(this, this._onClick_CalendarCell));
        syncFusionCalendar.on("timelineScroll", lang.hitch(this, this._onCalendarTimelineScroll));
        //syncFusionCalendar.on("search", lang.hitch(this, this._onCalendarSearch));

        syncFusionCalendar.on("viewChange", lang.hitch(this, this._onCalendarViewChange));
        syncFusionCalendar.on("searchresult", lang.hitch(this, this._onCalendar_SearchResult));

        syncFusionCalendar.adjustSchedulerHeight(this.cbAutoAdjust.checked);

        syncFusionCalendar.on("setScheduleEventsComplete", lang.hitch(this, this._onSetScheduleEventsComplete))


        // LISTVIEW
        let listviewCalendar = new CalendarListView();
        this.listView = listviewCalendar;
        listviewCalendar.placeAt(this.listView_container);

        listviewCalendar.on("dayClick", lang.hitch(this, this._onClick_ListViewDay));
        listviewCalendar.on("scroll", lang.hitch(this, this._onListviewScroll));
        listviewCalendar.on("unloadedMonths", lang.hitch(this, this._onListViewMonthCreated));
        listviewCalendar.on("itemClick", lang.hitch(this, this._onListViewItemClick));
        listviewCalendar.on("searchresult", lang.hitch(this, this._onCalendar_SearchResult));
        listviewCalendar.on("addItemsComplete", lang.hitch(this, this._onSetScheduleEventsComplete));

        listviewCalendar.getCurrentSelectedFilterIDs = lang.hitch(this, this.getActiveFilterIDs);

        this.StandbyStop();

        this.emit("calendarCreated", syncFusionCalendar);

        if (this.hasFeature("webcalendar/quicksearch")) {
            let search = this.getUrlParameterValue("qs");
            if (search) {
                //this.inputQuicksearch.setValue(decodeURIComponent(search));
                this.setQuickSearchTerm(decodeURIComponent(search));
                this.expandPane(WebcalendarTypes.WebCalendar_DefaultPanes.filterPane);
            }
        } else {
            this.removeUrlParameter("qs");
        }

        if (window.sidebar.isOpened === true) {
            this.onOpeningNavBar();
        }

        //tooltip
        this.syncFusionCalendar.enableToolTip = this.hasFeature("webcalendar/enableTooltip") || this.hasFeature("webcalendar/enableLocalTooltip");
        this.syncFusionCalendar.tooltipFetchDataFunction = this.hasFeature("webcalendar/enableTooltip") ? "Webtool_API_Webcalendar__GetToolTipData" : null; /* bei lokalem Tooltip keine fetch-Funktion! */
    }

    private _onListViewMonthCreated() {
        this._loadDataOfRange(null, 100);
    }


    private _onListViewItemClick(data: WebcalendarTypes.WebCalendarItemData_Default, evt: MouseEvent) {
        //Stop event otherwise calendar cell clickfunction is being triggered to
        evt.stopPropagation();
        this.itemClickFunction(data);
    }

    private _onClick_ListViewDay(data: WebcalendarTypes.CellClickData_Simple) {

        let bHandled = false;

        this.overrideCalendarClickTime(data);

        if (this.enableBookingCreation) {
            this._onclickOpenBookingEditor(null, data);

            this.emit("calendarCellClicked", data); // weiter reichnen

            bHandled = true;
        }

        else if (this.enablePrivAppointmentCreation) {
            this._onclickOpenPrivAppointmentEditor(null, data);

            this.emit("calendarCellClicked", data); // weiter reichnen
            bHandled = true;
        }

        else if (this.enablePlanninObjectOperatorCreation) {
            this.emit("calendarCellClicked", data); // weiter reichnen

            bHandled = true;
        }



    }
    private _onClick_CalendarCell(data: WebcalendarTypes.CellClickData_Simple) {
        let bHandled = false;

        this.overrideCalendarClickTime(data);

        if (this.enableBookingCreation) {
            //console.log("_onClick_CalendarCell", args);
            this.emit("calendarCellClicked", data); // weiter reichnen

            this._onclickOpenBookingEditor(null, data);

            bHandled = true;
        }

        else if (this.enablePrivAppointmentCreation) {
            //console.log("_onClick_CalendarCell", args);
            this.emit("calendarCellClicked", data); // weiter reichnen

            this._onclickOpenPrivAppointmentEditor(null, data);

            bHandled = true;
        }

        else if (this.enablePlanninObjectOperatorCreation) {
            this.emit("calendarCellClicked", data); // weiter reichnen

            bHandled = true;
        }


        // Klick aufs Datum führt zu diesem Datum:
        if (bHandled != true && this.syncFusionCalendar.getCurrentViewMode() == WebcalendarTypes.WebCalendar_ViewModes.year) {
            if (data.evt?.stopPropagation) data.evt.stopPropagation();
            // nächstbeste verfügbare Ansicht!
            if (this.selectedCalendarConfig.b_allow_view_day) {
                this.disableNode(this.calendarView_container);

                // mit Timeout, weil sonst unhandled exception im syncfusion-scheduler...
                setTimeout(lang.hitch(this, this.switchViewmode, WebcalendarTypes.WebCalendar_ViewModes.day, data.startTime), 100);
                setTimeout(lang.hitch(this, this.disableNode, this.calendarView_container, false), 110);
                //this.switchViewmode(WebcalendarTypes.WebCalendar_ViewModes.day, data.startTime);
            } else if (this.selectedCalendarConfig.b_allow_view_3days) {
                this.disableNode(this.calendarView_container);

                // mit Timeout, weil sonst unhandled exception im syncfusion-scheduler...
                setTimeout(lang.hitch(this, this.switchViewmode, WebcalendarTypes.WebCalendar_ViewModes.threeDays, dojoDate.add(data.startTime, "day", -1)), 100);
                setTimeout(lang.hitch(this, this.disableNode, this.calendarView_container, false), 110);

                //    this.switchViewmode(WebcalendarTypes.WebCalendar_ViewModes.threeDays, data.startTime);
            } else if (this.selectedCalendarConfig.b_allow_view_week) {
                this.disableNode(this.calendarView_container);


                // mit Timeout, weil sonst unhandled exception im syncfusion-scheduler...
                setTimeout(lang.hitch(this, this.switchViewmode, WebcalendarTypes.WebCalendar_ViewModes.week, data.startTime), 100);
                setTimeout(lang.hitch(this, this.disableNode, this.calendarView_container, false), 110);
                //    this.switchViewmode(WebcalendarTypes.WebCalendar_ViewModes.threeDays, data.startTime);
            } else if (this.isListViewModeAvailable()) {
                this.disableNode(this.calendarView_container);


                // mit Timeout, weil sonst unhandled exception im syncfusion-scheduler...
                setTimeout(lang.hitch(this, this.switchViewmode, WebcalendarTypes.WebCalendar_ViewModes.listView, data.startTime), 100);
                setTimeout(lang.hitch(this, this.disableNode, this.calendarView_container, false), 110);
                //    this.switchViewmode(WebcalendarTypes.WebCalendar_ViewModes.threeDays, data.startTime);
            }
        }

    }

    private overrideCalendarClickTime(data: WebcalendarTypes.CellClickData_Simple) {
        let viewMode = this.getCurrentViewMode();
        switch (viewMode) {
            case "year":
            case "month":
            case "list":
                if (this.hasUserRole("WebCalendar_OverrideCalendarClickTime") ) {
                    let module = (this.getModule as any)("EvBooking") as { defaultCalendarClickTime: { startTime: string, endTime: string } };

                    if (!module.defaultCalendarClickTime || !module.defaultCalendarClickTime.startTime || !module.defaultCalendarClickTime.endTime)  return;

                    let standardStart = new Date(module.defaultCalendarClickTime.startTime);
                    let standardEnd = new Date(module.defaultCalendarClickTime.endTime);

                    data.startTime.setHours(standardStart.getHours(), standardStart.getMinutes(), 0);
                    data.endTime.setHours(standardEnd.getHours(), standardEnd.getMinutes(), 0);
                }
                break;
        }
    }

    private onOpeningNavBar(sidebarWidth?: string): void { //sidebarWidth:  string mit "px" am ende
        if (typeof (sidebarWidth) == "undefined") {
            sidebarWidth = window.sidebar.sidebarWidth;
        }

        if (!window.sidebar?.isPinned) {
            sidebarWidth = "0px";
        }

        if (this.syncFusionCalendar) {
            setTimeout(lang.hitch(this.syncFusionCalendar, "redrawEvents"), 1000);
        }
        //this.syncFusionCalendar.refreshEvents();

        this._setSelectedMobileDiv("xx-none-xx", null);
    }

    private onClosingNavBar(): void {

        if (this.syncFusionCalendar) {
            setTimeout(lang.hitch(this.syncFusionCalendar, "redrawEvents"), 1000);
        }
    }

    private buttonsToAdd: Array<WebcalendarTypes.WebCalender_ViewButton>;
    addTopButton(name: string, label: string, clickFct: Function, showAsButton: boolean, showInViewMenu: boolean, iconClass?: string) {
        this.buttonsToAdd.push({
            name: name,
            label: label,
            function: clickFct,
            nodeName: "",
            iconClass: iconClass,
            showInViewMenu: showInViewMenu,
            showAsButton: showAsButton
        });
        this.createMissingTopButtons();
    }

    private createMissingTopButtons(): void {
        if (this.calendarButtons) {
            for (let entry of this.buttonsToAdd) {
                this.calendarButtons.addButton(entry);
            }

            this.buttonsToAdd = [];
        }
    }
    private updateDatePicker(startTime: Date, endTime: Date, viewingDate?: Date, selectedDate?: Date) {

        if (selectedDate) {
            this.datePicker.setDate(selectedDate);
        }

        if (viewingDate) {
            (this.datePicker as any).set("currentFocus", viewingDate, false);
        }
        //console.debug("updateDatePicker", startTime, endTime, viewingDate, selectedDate);
        if (startTime) this.datePicker.setMinDate(startTime);
        if (endTime) this.datePicker.setMaxDate(endTime);
        this.datePicker._populateGrid();

        this.updateCalendarButtonsLabel(startTime, endTime);

        //domStyle.set(this.datePane, "display", "block");
    }


    private updateCalendarButtonsLabel(startDate: Date, endDate: Date) {
        let view = this.syncFusionCalendar.getCurrentViewMode();


        let currentDate = this.datePicker.getShownDate();
        if (!currentDate) return;

        if (endDate?.setSeconds) {
            // eine Sekunde retour, weil bei manchen Ansichten gehts von Start 0:00 bis Ende 00:00, sollte aber Tag davor 23:59 sein
            endDate.setSeconds(-1);
        }

        let str = null;
        switch (view) {

            case WebcalendarTypes.WebCalendar_ViewModes.day:
                str = DateHelpers.dateToString(currentDate, "dd.MM.yyyy");
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.twoWeeks:
            case WebcalendarTypes.WebCalendar_ViewModes.threeDays:
                if (startDate && endDate) {
                    str = DateHelpers.dateToString(startDate, "dd.MM.yy - ") +
                        DateHelpers.dateToString(endDate, "dd.MM.yy");
                }
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.week:
                str = TranslationHelpers.translate("General_Label__CalendarWeek_ShortPrefix") + DateHelpers.getCalendarWeekNumber(currentDate) + DateHelpers.dateToString(endDate ? endDate : currentDate, " yyyy");
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.month:
                str = DateHelpers.dateToString(currentDate, "MMMM yyyy");
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.year:
            case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:
                str = currentDate.getFullYear().toString();
                break;


            case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:
            case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:
            case WebcalendarTypes.WebCalendar_ViewModes.timelineDay:
            case WebcalendarTypes.WebCalendar_ViewModes.listView:
            default:

                // in diesen Timelinemodu und Listenmodus nix machen! Range-Verwaltung wird da anders gemacht
                break;

        }

        this.calendarButtons.setRangeLabels(str, null, null);
    }
    private _actualSelectedDate: Date;
    private _onDatePickerPaging() {
        let newDate = this.datePicker.getShownDate();
        this._actualSelectedDate = newDate;
        //this.datePicker.set("value", newDate);
        if (this.viewBehaviour == "listview") {
            this.listView.goToDate(newDate, true);
        } else {
            this.syncFusionCalendar.setScheduleSelectedDate(newDate, false);
        }

    }
    private _onDatePickerMonthSelect() {
        let newDate = this.datePicker.getShownDate();
        this._actualSelectedDate = newDate;

        //this.datePicker.set("value", newDate);
        if (this.viewBehaviour == "listview") {
            this.listView.goToDate(newDate, true);
        } else {
            this.syncFusionCalendar.setScheduleSelectedDate(newDate, false);
        }

    }
    private _onchange_Datepicker() {
        if (this._ignoreDatePickerChange) return;
        let selectedDate = this.datePicker.get("value");
        this._actualSelectedDate = selectedDate;

        //console.debug(this.id + " _onchange_Datepicker", selectedDate);
        if (this.viewBehaviour == "listview") {
            this.listView.goToDate(selectedDate, true);
        } else {
            if (this.syncFusionCalendar) {
                this.syncFusionCalendar.scrollDate = selectedDate ? selectedDate : new Date();

                //this.syncFusionCalendar.setScheduleSelectedDate(d);
                //setTimeout(lang.hitch(this.syncFusionCalendar, this.syncFusionCalendar.scrollTo, null, d), 3000);


                if (this.syncFusionCalendar.isTimeLineMode()) {
                    let rangeIndex = this.syncFusionCalendar.getIndexOfRange(selectedDate);
                    let endOfRangeDate = this.syncFusionCalendar.getRangeDateLimitMax();

                    if (rangeIndex == -1 || !endOfRangeDate) return; // kann beim ersten Auftreten während des Aufbaus vorkommen, ist davor still (?) in eine exception gelaufen und stehen geblieben

                    let endOfRange = endOfRangeDate.getDate();
                    let targetIndex = selectedDate.getDate();
                    
                    let visibleDates = this.syncFusionCalendar.getVisibleDates().length;
                    let maxPossibleIndex = endOfRange - visibleDates;


                    let targetReachableByScroll = targetIndex <= maxPossibleIndex || rangeIndex < 3;

                    //console.log("index", rangeIndex, "endOfRange", endOfRange, "targetIndex", targetIndex, "maxPossibleIndex", maxPossibleIndex, "targetReachableByScroll", targetReachableByScroll);

                    if (rangeIndex != -1 && targetReachableByScroll) {
                        this.syncFusionCalendar.scrollTo(null, selectedDate);
                    } else {
                        this.syncFusionCalendar.scrollDate = selectedDate;

                        this.syncFusionCalendar.setScheduleSelectedDate(this.syncFusionCalendar.scrollDate);

                        setTimeout(lang.hitch(this.syncFusionCalendar, this.syncFusionCalendar.scrollTo, null, selectedDate), 3000);
                    }

                } else {
                    this.syncFusionCalendar.setScheduleSelectedDate(selectedDate);
                }
            }
        }
    }

    private _onCalendarViewChange(data: { view: WebcalendarTypes.WebCalendar_ViewTypes, date: Date }) {
        console.debug(this.id + " _onCalendarViewChange (syncfusion)", data);

        // syncfusionkalender ist nicht kooperativ mit diesem internen Umschaltklick im Monatsraster
        // der schaltet von Monat auf Tag um und wir müssten im SyncFusionCalendar.ts erst die ganze Registry updaten
        // weil dort sonst nicht mal das angeklickte Datum dabeisteht
        // wer das hier also nochmal probieren will, bitte...
        if (data?.view) {
            this.calendarButtons.setCurrentView(data.view as any);

            switch (data.view) {
                case WebcalendarTypes.WebCalendar_ViewTypes.day:
                case WebcalendarTypes.WebCalendar_ViewTypes.week:
                case WebcalendarTypes.WebCalendar_ViewTypes.month:
                case WebcalendarTypes.WebCalendar_ViewTypes.year:
                    this.calendarInterval = data.view;
                    this.calendarIntervalSteps = 1;
                    this.switchViewmode(data.view as any); // wär wichtig für URL-Anpassung und Minikalender etc...
                    break;
            }

        }
    }


    private _onCalendar_SearchResult(results: number) {
        let currentSearchterm = this.inputQuicksearch.getValue();

        let title = this.stringFormat(this.translate("WebCalendar__NoSearchResults_Formatstring_Toast"), results.toString(), currentSearchterm)

        if (results > 0) {
            title = this.stringFormat(this.translate("WebCalendar__SearchResults_Formatstring_Toast"), results.toString(), currentSearchterm)

        }
        this.showToast({
            title: title,
            iconClass: "fas fa-search",
            ID: "webcalendarQuicksearch",
            options: {
                buttons: [{
                    callback: lang.hitch(this, this.setQuickSearchTerm, null),
                    label: "",
                    icon: "fas fa-undo"
                }],
                timeout: "permanent",
                closeButton: false
            }
        });
    }
    private _onchange_Quicksearch(newValue: string) {
        this.applyQuicksearchValue();
    }

    private applyQuicksearchValue() {
        let keyword = this.inputQuicksearch.getValue();
        this.setQuickSearchTerm(keyword);
    }

    setQuickSearchTerm(keyword: string) {
        if (keyword) {
            this.setUrlParameter("qs", encodeURIComponent(keyword));
        } else {
            this.removeUrlParameter("qs");
            this.removeToast("webcalendarQuicksearch");
        }

        this.inputQuicksearch.setValue(keyword, true);

        this.UiModder.domClass.toggle(this.quickSearchContainer, "highlightBG", !!keyword);

        if (this.viewBehaviour != "listview") {
            if (this.syncFusionCalendar) {
                this.syncFusionCalendar.highlightItemsByKeyword(keyword);
            }
        } else {
            if (this.listView) {
                this.listView.highlightItemsByKeyword(keyword);
            }
        }
    }
    //private _onCalendarSearch(keyword: string) {
    //    this.inputQuicksearch.setValue(keyword);
    //    if (keyword) {
    //        this.setUrlParameter("qs", encodeURIComponent(keyword));
    //    } else {
    //        this.removeUrlParameter("qs");
    //    }
    //    this.UiModder.domClass.toggle(this.quickSearchContainer, "highlightBG", !!keyword);
    //}
    private _onListviewScroll() {

        let currentScrollDate = this.listView.getCurrentScrollDate();

        if (!currentScrollDate || !currentScrollDate.valueOf || isNaN(currentScrollDate.valueOf())) {
            console.warn("_onListviewScroll: invalid scrolldate!", currentScrollDate);
            return;
        }

        let visibleDates = this.listView.getVisibleDates();
        //console.debug(this.id + " _onListviewScroll", currentScrollDate, visibleDates);

        let maxDate = this.listView.getLatestDate();
        let minDate = this.listView.getEarliestDate();

        if (minDate) this.datePicker.set("minDate", minDate);
        if (maxDate) this.datePicker.set("maxDate", maxDate);
        this.datePicker._populateGrid();

        let months: Array<string> = [];

        if (minDate && maxDate) {
            let loopDate = new Date(minDate.valueOf());

            while (loopDate.valueOf() <= maxDate.valueOf()) {
                let monthStr = this.dateToString(loopDate, "MMMM yyyy");
                if (months.indexOf(monthStr) == -1) months.push(monthStr);

                loopDate.setMonth(loopDate.getMonth() + 1);

                if (months.length == 999) break; // NOtausstieg
            }
        }

        if (visibleDates?.length) {
            this._ignoreDatePickerChange = true;
            let middleDate = visibleDates[0];
            if (visibleDates.length > 1) middleDate = visibleDates[Math.ceil(visibleDates.length / 2)];

            this.updateDatePicker(null, null, null, currentScrollDate ? currentScrollDate : middleDate);
            this.datePicker._markSelectedDates(visibleDates);
            this._ignoreDatePickerChange = false;
        }

        let rangeStepsBefore: number = null;
        let rangeStepsAfter: number = null;
        let currentIndex: number = 0;

        if (currentScrollDate && currentScrollDate.valueOf) {
            //this.setUrlParameter("ds", currentScrollDate.valueOf().toString());
            this._delaySetUrlParameterDS(currentScrollDate);

            let todayStr = this.dateToString(currentScrollDate, "MMMM yyyy");
            rangeStepsAfter = months.length - 1;
            currentIndex = -1;
            rangeStepsBefore = 0;

            for (let i = 0; i < months.length; i++) {
                currentIndex++;
                let compareStr = months[i];
                if (compareStr == todayStr) {
                    break;
                }
            }
        }


        this.calendarButtons.setupRange(
            rangeStepsBefore,
            rangeStepsAfter,
            currentIndex,
            this.dateTimeToString(currentScrollDate, "dd.MM.yyyy"),
            this.dateTimeToString(minDate, "dd.MM.yyyy"),
            this.dateTimeToString(maxDate, "dd.MM.yyyy")
        );
    }
    private _onCalendarTimelineScroll() {

        let currentScrollDate = this.syncFusionCalendar.scrollDate;

        if (!currentScrollDate || !currentScrollDate.valueOf || isNaN(currentScrollDate.valueOf())) {
            console.warn("_onCalendarTimelineScroll: invalid scrolldate!", currentScrollDate);
            return;
        }

        let visibleDates = this.syncFusionCalendar.getVisibleDates();
        //console.debug(this.id + " _onCalendarTimelineScroll", currentScrollDate, visibleDates);


        let currentRangeIndex = this.syncFusionCalendar.getIndexOfRange();
        let maxDate = this.syncFusionCalendar.getRangeDateLimitMax();
        let minDate = this.syncFusionCalendar.getRangeDateLimitMin();


        // hier unschönes Normalisieren des Index:
        // der Kalender hat seine Ranges 0-basiert (0-3, 0-6 bei Detail)
        // die Kalenderbuttons verwalten ihre Ranges aber von -2..1 und -3...+3. Also gehört immer ein Offset dazu.
        switch (this.syncFusionCalendar.getCurrentViewMode()) {
            case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:
                currentRangeIndex = currentRangeIndex - 2;
                break;
            case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:
            case WebcalendarTypes.WebCalendar_ViewModes.timelineDay:
                currentRangeIndex = currentRangeIndex - 3;
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:
                currentRangeIndex = 0; // immer 0, Jahr hat keine Range in dem Sinn
                currentScrollDate = this.syncFusionCalendar.getCurrentSelectedDate();
                break;
        }
        if (visibleDates?.length) {
            this._ignoreDatePickerChange = true;
            this.updateDatePicker(null, null, null, currentScrollDate ? currentScrollDate : visibleDates[0]);
            this.datePicker._markSelectedDates(visibleDates);
            this._ignoreDatePickerChange = false;
        }

        //console.debug(this.id + " _onCalendarTimelineScroll", this.dateTimeToString(currentScrollDate, "dd.MM.yyyy"));

        if (currentScrollDate && currentScrollDate.valueOf) {
            //this.setUrlParameter("ds", currentScrollDate.valueOf().toString());
            this._delaySetUrlParameterDS(currentScrollDate);
        }

        if (this.calendarInterval == WebcalendarTypes.WebCalendar_ViewTypes.year) {
            this.calendarButtons.setupRange(
                null,
                null,
                0,
                this.dateTimeToString(currentScrollDate, "yyyy")
            );
        } else {
            this.calendarButtons.setupRange(
                null,
                null,
                currentRangeIndex,
                this.dateTimeToString(currentScrollDate, "dd.MM.yyyy"),
                this.dateTimeToString(minDate, "dd.MM.yyyy"),
                this.dateTimeToString(maxDate, "dd.MM.yyyy")
            );
        }
    }

    private _onCalendarButtonsNavigation(view: WebcalendarTypes.WebCalendar_ViewModes | WebcalendarTypes.WebCalendar_ViewInstructions) {
        //console.debug(this.id + " _onCalendarButtonsNavigation (calendarbuttons)", view

        this.switchViewmode(view);
        //    this.updateDatePicker(this.syncFusionCalendar.earliestDate, this.syncFusionCalendar.latestDate);
    }

    private configureButtons() {
        if (!this.calendarButtons) {
            this.calendarButtons = new Calendar_Buttons();
            let topBar_item_right = document.getElementById("mainMenuGlobalSpace");
            this.calendarButtons.placeAt(topBar_item_right);

            this.calendarButtons.on("viewChange", lang.hitch(this, this._onCalendarButtonsNavigation));

            this.emit("calendarButtonsSetup");
        }

        if (this.selectedCalendarConfig) {
            let config = this.selectedCalendarConfig;

            this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.day, config.b_allow_view_day);
            this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.threeDays, config.b_allow_view_3days);
            this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.week, config.b_allow_view_week);
            this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.twoWeeks, config.b_allow_view_2weeks);
            this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.month, config.b_allow_view_month);

            if (typeof (config.b_allow_view_year) == "boolean" && this.hasFeature("Webcalendar/YearViews")) {
                this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.year, config.b_allow_view_year);

            } else {
                this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.year, false);
            }

            if (this.hasFeature("Webcalendar/listview")) {
                if (typeof (config.b_allow_view_list) == "boolean") {
                    this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.listView, config.b_allow_view_list);
                } else {
                    this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.listView, true);
                }
            }

            if (this.hasFeature("Webcalendar/Timeline")) {
                if (typeof (config.b_allow_view_timelinedetail) == "boolean") {
                    this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineDetail, config.b_allow_view_timelinedetail);
                } else {
                    this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineDetail, false);
                }

                if (typeof (config.b_allow_view_timelineoverview) == "boolean") {
                    this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineOverview, config.b_allow_view_timelineoverview);
                } else {
                    this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineOverview, false);
                }

                if (typeof (config.b_allow_view_timelineyear) == "boolean" && this.hasFeature("Webcalendar/YearViews")) {
                    this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineYear, config.b_allow_view_timelineyear);
                } else {
                    this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineYear, false);
                }


                if (typeof (config.b_allow_view_timelineday) == "boolean") {
                    this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineDay, config.b_allow_view_timelineday);
                } else {
                    this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineDay, false);
                }

                //    if (typeof (config.b_allow_view_timelineday) == "boolean") {
                //        this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineDay, config.b_allow_view_timelineday);
                //    } else {
                //        this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineDay, true);
                //    }
            }
            //this.calendarButtons.allowView("timeline", config.b_allow_view_timeline);
        }
    }

    private switchViewmode(newMode: WebcalendarTypes.WebCalendar_ViewModes | WebcalendarTypes.WebCalendar_ViewInstructions, gotoDate?: Date) {
        if ( !this.syncFusionCalendar ){
            return;
        }

        // ############################################################
        let newViewBehaviour: viewbehaviour = null;// this.viewBehaviour; // "calendar";
        let currentViewMode: WebcalendarTypes.WebCalendar_ViewModes = this.syncFusionCalendar.getCurrentViewMode();
        let newViewMode: WebcalendarTypes.WebCalendar_ViewModes = currentViewMode;
        let currentViewBehaviour: viewbehaviour = this.viewBehaviour;


        // je nach aktuellem Modus und was da kommt kann der SF sein Zeug mal resetten
        let bResetRender = true;
        if (currentViewBehaviour == "listview") {
        } else {
            switch (newMode) {
                case WebcalendarTypes.WebCalendar_ViewInstructions.stepBackward:
                case WebcalendarTypes.WebCalendar_ViewInstructions.stepForward:
                    if (currentViewBehaviour == "timeline") {
                        // timeline, innerhalb der Range wird "gescrollt" mit step - kein Reset
                        bResetRender = false;
                    }
                    break;
            }
        }

        if (bResetRender) {
            this.syncFusionCalendar.clearEventsAndRender(); //reset von display stuff
        }

        switch (newMode) {
            case WebcalendarTypes.WebCalendar_ViewInstructions.reload:
                this.reloadData(null, 100);

                break;
            case WebcalendarTypes.WebCalendar_ViewModes.listView:
                newViewBehaviour = "listview";
                newViewMode = newMode;

                //this.calendar.dayButtonClick();
                this.calendarInterval = WebcalendarTypes.WebCalendar_ViewTypes.list;
                this.calendarIntervalSteps = 1;

                this.calendarButtons.setupRange(0, 0);

                this.setUrlParameter("vm", newMode);
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.day:
                newViewBehaviour = "calendar";
                newViewMode = newMode;

                //this.calendar.dayButtonClick();
                this.calendarInterval = WebcalendarTypes.WebCalendar_ViewTypes.day;
                this.calendarIntervalSteps = 1;

                this.calendarButtons.setupRange(0, 0);

                this.syncFusionCalendar.changeView(newMode);

                this.setUrlParameter("vm", newMode);
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.threeDays:
                newViewBehaviour = "calendar";
                newViewMode = newMode;

                this.calendarInterval = WebcalendarTypes.WebCalendar_ViewTypes.day;
                this.calendarIntervalSteps = 3;

                this.calendarButtons.setupRange(0, 0);

                this.syncFusionCalendar.changeView(newMode);

                this.setUrlParameter("vm", newMode);
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.week:
                newViewBehaviour = "calendar";
                newViewMode = newMode;

                this.calendarInterval = WebcalendarTypes.WebCalendar_ViewTypes.week;
                this.calendarIntervalSteps = 1;

                this.calendarButtons.setupRange(0, 0);

                this.syncFusionCalendar.changeView(newMode);

                this.setUrlParameter("vm", newMode);
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.twoWeeks:
                newViewBehaviour = "calendar";
                newViewMode = newMode;

                this.calendarInterval = WebcalendarTypes.WebCalendar_ViewTypes.week;
                this.calendarIntervalSteps = 2;

                this.calendarButtons.setupRange(0, 0);

                this.syncFusionCalendar.changeView(newMode);

                this.setUrlParameter("vm", newMode);
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.month:
                newViewBehaviour = "calendar";
                newViewMode = newMode;

                this.calendarInterval = WebcalendarTypes.WebCalendar_ViewTypes.month;
                this.calendarIntervalSteps = 1;
                this.calendarButtons.setupRange(0, 0);
                this.syncFusionCalendar.changeView(newMode);
                this.setUrlParameter("vm", newMode);
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.year:
                newViewBehaviour = "calendar";
                newViewMode = newMode;

                this.calendarInterval = WebcalendarTypes.WebCalendar_ViewTypes.year;
                this.calendarIntervalSteps = 1;
                this.calendarButtons.setupRange(0, 0, 0, this.datePicker.getShownYear().toString());
                this.syncFusionCalendar.changeView(newMode);
                this.setUrlParameter("vm", newMode);
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:
                newViewBehaviour = "timeline";
                newViewMode = newMode;

                this.calendarInterval = WebcalendarTypes.WebCalendar_ViewTypes.year;

                this.calendarButtons.setupRange(0, 0, 0, "");
                this.setUrlParameter("vm", newMode);

                break;
            case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:
                newViewBehaviour = "timeline";
                newViewMode = newMode;

                this.calendarInterval = WebcalendarTypes.WebCalendar_ViewTypes.month;

                this.calendarButtons.setupRange(2, 1, 0, "", "", "");
                this.setUrlParameter("vm", newMode);

                break;

            case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:
                newViewBehaviour = "timeline";
                newViewMode = newMode;

                this.calendarInterval = WebcalendarTypes.WebCalendar_ViewTypes.week;

                this.calendarButtons.setupRange(3, 3, 0, "", "", "");
                this.setUrlParameter("vm", newMode);

                break;

            case WebcalendarTypes.WebCalendar_ViewModes.timelineDay:
                newViewBehaviour = "timeline";
                newViewMode = newMode;

                this.calendarInterval = WebcalendarTypes.WebCalendar_ViewTypes.day;

                this.calendarButtons.setupRange(0, 0, 0, "", "", "");
                this.setUrlParameter("vm", newMode);
                break;

            case WebcalendarTypes.WebCalendar_ViewInstructions.next:
            case WebcalendarTypes.WebCalendar_ViewInstructions.previous:
                if (this.viewBehaviour == "listview") {
                    this.listView.step(newMode == "next" ? 1 : -1, "day");
                } else {
                    this.syncFusionCalendar.changeView(newMode);
                }
                break;

            case WebcalendarTypes.WebCalendar_ViewInstructions.stepBackward:
                // zurückscrollen
                if (this.viewBehaviour == "listview") {
                    this.listView.step(-1, "day");
                } else {
                    this.syncFusionCalendar.step(-1);
                }
                break;

            case WebcalendarTypes.WebCalendar_ViewInstructions.stepForward:
                // vorwärtsscrollen
                if (this.viewBehaviour == "listview") {
                    this.listView.step(1, "day");
                } else {
                    this.syncFusionCalendar.step(1);
                }
                break;

            case WebcalendarTypes.WebCalendar_ViewInstructions.previousRange:
                // den vorherigen Bereich laden
                //this.calendarButtons.setupRange(1, 1, 0, "range-", "minRange", "maxRange");
                if (this.viewBehaviour == "listview") {
                    this.listView.step(-1, "month");
                } else {
                    this.syncFusionCalendar.step("min");
                }
                break;
            case WebcalendarTypes.WebCalendar_ViewInstructions.nextRange:
                // in den nächsten Bereich wechseln
                //this.calendarButtons.setupRange(1, 1, 0, "range+", "minRange", "maxRange" );
                if (this.viewBehaviour == "listview") {
                    this.listView.step(1, "month");
                } else {
                    this.syncFusionCalendar.step("max");
                }
                break;

            case WebcalendarTypes.WebCalendar_ViewInstructions.rangeMax:
                // ans Ende der aktuellen Range wechseln
                //this.calendarButtons.setRangeLabels("maxRange", "minRange", "maxRange");
                if (this.viewBehaviour == "listview") {
                    this.listView.step("max");
                } else {
                    this.syncFusionCalendar.step("max");
                }
                break;

            case WebcalendarTypes.WebCalendar_ViewInstructions.rangeMin:
                // an den Anfang der aktuellen Range wechseln
                //this.calendarButtons.setRangeLabels("minRange", "minRange", "maxRange");
                if (this.viewBehaviour == "listview") {
                    this.listView.step("min");
                } else {
                    this.syncFusionCalendar.step("min");
                }
                break;

            case WebcalendarTypes.WebCalendar_ViewInstructions.today:
                if (this.viewBehaviour == "listview") {
                    this.listView.goToDate(new Date());
                }
                else if (this.viewBehaviour == "timeline") {
                    this.syncFusionCalendar.changeView(newMode);
                } else {
                    //this.calendar.todayButtonClick();
                    //this.calendarButtons.setMode(WebcalendarTypes.WebCalendar_ViewModes.day, false); // Anzeige im Navigator umschalten!
                    this.calendarButtons.setupRange(0, 0);
                    this.syncFusionCalendar.changeView(newMode);
                }
                break;
        }

        if (newViewBehaviour) {

            this.previousViewBehaviour = this.viewBehaviour;
            this.viewBehaviour = newViewBehaviour;

            //// das toggle muss immer passieren, sonst funktioniert Umschalten zwischen Modi nicht
            //this.switchViewmode(view as WebcalendarTypes.WebCalendar_ViewModes);

            if (newViewMode) this.calendarButtons.setCurrentView(newViewMode);

            try {
                let userData: userCalendarSettings = this.getUserCalendarSettingsFromStore();
                userData.lastSetViewMode = newMode as WebcalendarTypes.WebCalendar_ViewModes;
                this.saveUserSettingsToStorage(userData);
            } catch (ex) {
                // dann wirds halt nicht gespeichert, ja mei.
            }
        } else {
            // hinweis: früher ware dieser ganze Codeblock bis zu den Rauten im oncalendarbuttons-navigation
            // und da ist das switchViewMode nur überhaupt passiert, wenn newViewBehaviour.
            // wenn es Instructions ohne viewBehaviour waren, dann hier raus:
            return;
        }

        // ############################################################



        let bSwitchToTimeline: boolean = this.viewBehaviour == "timeline";
        let bSwitchToListView: boolean = this.viewBehaviour == "listview";

        this.handleMainContainerVisibility(newViewMode);


        //viewmode == WebcalendarTypes.WebCalendar_ViewModes.timelineDetail ||
        //viewmode == WebcalendarTypes.WebCalendar_ViewModes.timelineOverview ||
        //viewmode == WebcalendarTypes.WebCalendar_ViewModes.timelineDay;


        //if (this.syncFusionCalendar.isTimeLineMode() == timelineTarget) {
        //    return; // target already set
        //}

        //let currentMode = this.syncFusionCalendar.getCurrentViewMode();


        let currentModeByButtons = this.calendarButtons.getSelectedViewMode();
        if (!newViewMode && currentModeByButtons) {
            newViewMode = currentModeByButtons;
        }


        let targetDate = this._actualSelectedDate;// this.datePicker.getShownDate();

        if (this.previousViewBehaviour == "listview") {
            targetDate = this.listView.getCurrentScrollDate();
        }
        if (this.previousViewBehaviour == "timeline") {
            targetDate = this.syncFusionCalendar.scrollDate;
        }

        if (gotoDate) {
            targetDate = gotoDate;
        }

        // FALLBACK:
        if (!targetDate) targetDate = this.datePicker.getShownDate(); //get("value");
        if (!targetDate) targetDate = new Date();

        if (targetDate) {
            this.syncFusionCalendar.setScheduleSelectedDate(targetDate, false);
            this.syncFusionCalendar.scrollDate = targetDate;
        }
        if (!bSwitchToListView) {

            this.syncFusionCalendar.setViewMode(newViewMode);
        }


        if (bSwitchToListView && this.previousViewBehaviour != "listview") {

            let dates = this.syncFusionCalendar.getVisibleDates(); // falls mehrere Monate sichtbar sind, soll die Listenansicht ihre Registry daraus erstellen!
            if (!dates ||
                !dates.length) {
                dates = [];
            }

            // kürzen wenn zu viel!
            if (dates.length > 100) {
                dates = dates.slice(0, 100);
            }

            if (targetDate) {
                dates.push(targetDate);
                setTimeout(lang.hitch(this.listView, "goToDate", targetDate), 1200); // achtung: dass passiert NACH dem Setup, das UNTER dem if-Block steht :)
            }

            this.listView.setup(dates, targetDate);
        }

        //if (this.calendarInterval == "year") debugger;

        let bIsYearCalendar = this.calendarInterval == WebcalendarTypes.WebCalendar_ViewTypes.year && this.viewBehaviour == "calendar";
        let bIsYearTimeline = this.calendarInterval == WebcalendarTypes.WebCalendar_ViewTypes.year && this.viewBehaviour == "timeline";

        this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.yearViewPane, bIsYearCalendar || bIsYearTimeline);
        this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane, this.selectedCalendarConfig.b_hide_all_options != true && !bIsYearCalendar);
        this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.datePane, !bIsYearCalendar && !bIsYearTimeline);
        this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.resourcesPane, this.viewBehaviour == "timeline" && this.resourceGroupRegistry?.length > 0);
        this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.viewOptionsPane, this.selectedCalendarConfig.b_hide_all_options != true && !bIsYearCalendar);

        this.hideNode(this.autoAdjust_container, this.viewBehaviour == "listview");
        this.hideNode(this.calendarZoomContainer, this.viewBehaviour == "listview");
        this.hideNode(this.btnShowEmptyGroups, this.viewBehaviour != "calendar");
        this.hideNode(this.showStartTime_container, !bIsYearTimeline);



        //this.calendarButtons.allowView("all", false);
        //this.calendarButtons.allowView(WebcalendarTypes.WebCalendar_ViewModes.timeline);


        if (this.viewBehaviour == "timeline") {

            this.showEmptyDataGroups(false, true);
            this.showDataGroups(false, true);

            this.hideNode(this.data_grouping_container);
            this.disableNode(this.btnEnableDatagrouping);
            this.disableNode(this.btnShowEmptyGroups);

            if (bIsYearTimeline) {
                // bei Jahrestimeline erst mal ohne Ressourcen starten
                //this.syncFusionCalendar.removeAllGroupingResources();


                // angewählte/vorausgewählte deaktivieren:
                for (let i = 0; i < this.resourceGroupRegistry.length; i++) {
                    this.disableNode(this.resourceGroupRegistry[i].button, !bSwitchToTimeline);
                    let registeredResource = this.resourceGroupRegistry[i];
                    if (registeredResource.selected == true) {
                        this._onClick_ToggleResourceGroup(registeredResource);
                    }
                }

            } else {
                for (let i = 0; i < this.resourceGroupRegistry.length; i++) {
                    this.disableNode(this.resourceGroupRegistry[i].button, !bSwitchToTimeline);
                    let registeredResource = this.resourceGroupRegistry[i];
                    if (registeredResource.selected == true) {
                        this.applyResourceGroup(true, registeredResource.resourceData.DescriptorId)
                    }
                }

            }


        } else {
            if (this.selectedCalendarConfig) {
                let config = this.selectedCalendarConfig;


                //this.showEmptyDataGroups(this.cbEnableDatagrouping.checked);
                //this.showDataGroups(this.cbShowEmptyGroups.checked);
                if (typeof (config.ref_web_calendar?.bDataGroupingAvailable) == "boolean") {
                    this.hideNode(this.data_grouping_container, config.ref_web_calendar.bDataGroupingAvailable == false);;
                }
                this.disableNode(this.btnEnableDatagrouping, false);// !config.b_show_datagroups);
                this.disableNode(this.btnShowEmptyGroups, false);// !config.b_show_empty_groups);

                if (this.viewBehaviour == "listview") {

                } else if (this.viewBehaviour == "calendar") {
                    this.syncFusionCalendar.removeAllGroupingResources();

                }

            }

        }

        if (this.previousViewBehaviour != this.viewBehaviour) {
            this.applyQuicksearchValue();
        }

        if (bIsYearCalendar || bIsYearTimeline) {
            this._setYearViewParameters();
        }
    }



    private _onGridDoubleClick(evtArgs): void {
        if (typeof (this.gridDoubleClickFunction) == "function") {
            this.gridDoubleClickFunction(evtArgs.date)
        }
    }


    setCalendarConfig(config: WebcalendarTypes.WebCalendar_Config): void {

        this.selectedCalendarConfig = config

        if (!config) return;


        // coloration-Attributes zusammenstellen:
        let colors: Array<WebcalendarTypes.WebCalendar_ColorAttribute> = [];
        for (let htColor of config.ref_web_calendar.EL_ht_web_calendar_colorattribute_web_calendar) {
            colors.push(htColor.ref_web_calendar_colorattribute);
        }

        this.setIsDndEditingEnabled(config["is_dnd_editing_enabled"])

        this.processConfigColors(colors);
        this._loadCalendarResources(config.ref_web_calendar.ID);
        this.setFilters(config.ref_web_calendar.EL_ht_web_calendar_filter_web_calendar);

        this.configureButtons();

        let userSettings = this.getUserCalendarSettingsFromStore();

        if (typeof (userSettings.YearViewFirstMonth) == "number") {
            this.inputYearViewStartMonth.setValue(userSettings.YearViewFirstMonth, true);
        }

        if (typeof (userSettings.YearViewMonthsCount) == "number") {
            this.inputYearViewMonthCount.setValue(userSettings.YearViewMonthsCount, true);
        }

        let targetView = this._overrideViewMode;
        // ohne override (aus URL): mal in die Usersettings schauen, ob da was drin steht

        if (!targetView) {
            if (userSettings) {
                if (userSettings.lastSetViewMode) {
                    targetView = userSettings.lastSetViewMode;
                }
            }
        }

        // prüfen ob zulässig:

        if (targetView) {
            switch (targetView) {
                case WebcalendarTypes.WebCalendar_ViewModes.day:
                    if (!config.b_allow_view_day) targetView = null;
                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.threeDays:
                    if (!config.b_allow_view_3days) targetView = null;
                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.week:
                    if (!config.b_allow_view_week) targetView = null;
                    break;


                case WebcalendarTypes.WebCalendar_ViewModes.twoWeeks:
                    if (!config.b_allow_view_2weeks) targetView = null;
                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.month:
                    if (!config.b_allow_view_month) targetView = null;
                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.year:
                    if (!config.b_allow_view_year || !this.hasFeature("webcalendar/yearviews")) targetView = null;
                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.listView:
                    if (!this.hasFeature("webcalendar/listview")) {
                        targetView = null;
                    }
                    if (config.b_allow_view_list === false) {
                        targetView = null;
                    }
                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:
                    if (!this.hasFeature("webcalendar/timeline") || !this.hasFeature("webcalendar/yearviews")) {
                        targetView = null;
                    }
                    if (config.b_allow_view_timelineyear === false) {
                        targetView = null;
                    }
                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:
                    if (!this.hasFeature("webcalendar/timeline")) {
                        targetView = null;
                    }
                    if (config.b_allow_view_timelineoverview === false) {
                        targetView = null;
                    }
                    break;
                case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:
                    if (!this.hasFeature("webcalendar/timeline")) {
                        targetView = null;
                    }
                    if (config.b_allow_view_timelinedetail === false) {
                        targetView = null;
                    }
                    break;
                case WebcalendarTypes.WebCalendar_ViewModes.timelineDay:

                    if (!this.hasFeature("webcalendar/timeline")) {
                        targetView = null;
                    }
                    if (config.b_allow_view_timelinedetail === false) {
                        targetView = null;
                    }
                    break;

                default:
                    targetView = null;
                    break;
            }
        }

        // nix? dann aus config den Standard holen:
        if (!targetView) targetView = config.default_view;

        if (!targetView) targetView = WebcalendarTypes.WebCalendar_ViewModes.day; // wenn jetz immer noch nix kommt dann is halt a Topfen.


        //// nur setzen, wenn es nicht von außerhalb irgendwie übersteuert ist?!
        //this.set("allowedViews",
        //    config.b_allow_view_day,
        //    config.b_allow_view_week,
        //    config.b_allow_view_month,
        //    config.b_allow_view_3days,
        //    config.b_allow_view_2weeks,
        //    true//config.b_allow_view_timeline
        //);


        this.setDefaultView(targetView);



        let preset = userSettings.showTimeIndicator;
        if (typeof (preset) != "boolean") preset = config.b_show_timeindicator;
        this.setShowTimeIndicator(preset);

        preset = userSettings.showEmptyGroups;
        if (typeof (preset) != "boolean") preset = config.b_show_empty_groups;
        this.showEmptyDataGroups(preset);

        preset = userSettings.showDataGroups;
        if (typeof (preset) != "boolean") preset = config.b_show_datagroups;
        this.showDataGroups(preset);

        preset = userSettings.showEndTime;
        if (typeof (preset) != "boolean") preset = config.b_show_end_time;
        if (typeof (preset) != "boolean") preset = this.__displaySettings.b_show_end_time;
        if (typeof (preset) != "boolean") preset = false;
        this.setShowEndTime(preset);

        preset = userSettings.showStartTime;
        if (typeof (preset) != "boolean") preset = config.b_show_start_time;
        if (typeof (preset) != "boolean") preset = this.__displaySettings.b_show_start_time;
        if (typeof (preset) != "boolean") preset = false;
        this.setShowStartTime(preset);



        // einmal Styles rechnen:
        //this.toggleCb(this.cbShowEmptyGroups, this.btnShowEmptyGroups, this.cbShowEmptyGroups.checked); // wird schon übers Set gemacht
        //this.toggleCb(this.cbEnableDatagrouping, this.btnEnableDatagrouping, this.cbEnableDatagrouping.checked); // wird schon übers Set gemacht
        this.toggleCb(this.cbShowEndTime, this.btnShowEndTime, this.cbShowEndTime.checked);
        this.toggleCb(this.cbShowStartTime, this.btnShowStartTime, this.cbShowStartTime.checked);


        if (typeof (userSettings.scaleFactor) == "number") {
            this._updateZoom(userSettings.scaleFactor);
        }

        preset = userSettings.autoAdjust;
        if (typeof (preset) != "boolean") preset = this.__displaySettings.autoAdjustToDisplay;
        if (typeof (preset) != "boolean") preset = this.cbAutoAdjust.checked;
        let hasChanged = this.toggleCb(this.cbAutoAdjust, this.btnAutoAdjust, preset);
        if (hasChanged) {
            this.onChange_autoAdjust();
        }

        preset = userSettings.showTimeIndicator;
        if (typeof (preset) != "boolean") preset = this.cbShowTimeIndicator.checked;
        this.toggleCb(this.cbShowTimeIndicator, this.btnShowTimeIndicator, preset);


        //this.toggleCb(this.cbHideColumHeadIfNeeded, this.btnHideColumHeadIfNeeded, false); // wird gar nicht mehr gebraucht

        if (config.b_hide_all_options === true) {
            this.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.viewOptionsPane);
        }
        else {
            //this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.viewOptionsPane);
        }


        if (config.b_hide_coloration === true) {
            this.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane);
        }
        else {
            //this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane);
        }

        if (config.b_hide_searchpane === true || !this.hasFeature("Webcalendar/Searchpanel")) {
            this.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.searchPane);
        } else {
            this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.searchPane);
        }

        this._overrideViewMode = null;

        if (this.viewBehaviour != "timeline") {
            this.loadDataOfRange_Delayed();
        }
    }

    private _currentZoomFactor: number = 1;
    private _onClick_AdjustScaleMinus(evt: MouseEvent) {
        let newZoom = this._currentZoomFactor - 0.2;
        if (newZoom < 0.4) newZoom = 0.4;

        if (this.toggleCb(this.cbAutoAdjust, this.btnAutoAdjust, false) == true) {
            this.onChange_autoAdjust();
        }

        this._updateZoom(newZoom);
    }
    private _onClick_AdjustScalePlus(evt: MouseEvent) {
        let newZoom = this._currentZoomFactor + 0.2;
        if (newZoom > 3) newZoom = 3;

        if (this.viewBehaviour != "timeline") {
            if (this.toggleCb(this.cbAutoAdjust, this.btnAutoAdjust, false) == true) {
                this.onChange_autoAdjust();
            }
        }


        this._updateZoom(newZoom);
    }

    private _redrawTimeout: any = null;
    private _updateZoom(newValue: number, bSkipRedraw?: boolean) {

        if (!newValue) return;
        if (this._currentZoomFactor == newValue) return;

        this._currentZoomFactor = newValue;

        if (this._redrawTimeout != null) {
            clearTimeout(this._redrawTimeout);
        }

        this.txtCurrentScale.innerHTML = this._currentZoomFactor.toFixed(1);

        if (bSkipRedraw !== true) {
            this._redrawTimeout = setTimeout(lang.hitch(this, function () {

                document.body.style.setProperty("--heightFactor", this._currentZoomFactor.toFixed(1));
                document.body.style.setProperty("--timelineWidthFactor", this._currentZoomFactor.toFixed(1));

                this.syncFusionCalendar.redrawEvents();

                if (this.viewBehaviour == "timeline") {
                    this.syncFusionCalendar.scrollTo(null, this.syncFusionCalendar.scrollDate);
                    //this.syncFusionCalendar.startViewportObserver();
                }
            }), 400);
        }

        let setting = this.getUserCalendarSettingsFromStore();
        setting.scaleFactor = this._currentZoomFactor;
        this.saveUserSettingsToStorage(setting);

    }

    private _delayedLoadHandle: any = null;
    loadDataOfRange_Delayed(targetItem?: WebcalendarTypes.WebCalendarItemData_Default, delay: number = 500) {
        if (this._delayedLoadHandle) clearTimeout(this._delayedLoadHandle);

        if (!delay || delay < 0) delay = 500;
        if (this.syncFusionCalendar){
            if (this.syncFusionCalendar.isTimeLineMode()) {
                try {
                    this._onCalendarTimelineScroll();
                } catch (ex) {

                }


            }
        }

        this._delayedLoadHandle = setTimeout(lang.hitch(this, this._loadDataOfRange, targetItem), delay);
    }
    getCurrentViewMode(): WebcalendarTypes.WebCalendar_ViewModes {
        let mode = this.syncFusionCalendar.getCurrentViewMode();
        let behav = this.viewBehaviour;
        let primitiveViewmode = this.syncFusionCalendar.getPrimitiveViewMode();

        switch (behav) {
            case "listview":
                return WebcalendarTypes.WebCalendar_ViewModes.listView;
                break;
            case "timeline":
                return mode;
                break;

            case "calendar":
                return mode;
                break;
        }
    }
    private _loadDataOfRange(targetItem?: WebcalendarTypes.WebCalendarItemData_Default, delay?: number) {
        if (typeof (delay) == "number") {
            this.loadDataOfRange_Delayed(targetItem, delay);
            return;
        }

        if (this._delayedLoadHandle) clearTimeout(this._delayedLoadHandle);
        let cal = this.getCurrentSelectedCalendar();
        if (!cal) return;

        if (!this.syncFusionCalendar){
            return;
        }

        let interval = this.syncFusionCalendar.scheduleCalendarInterval;

        let primitiveViewmode = this.syncFusionCalendar.getPrimitiveViewMode();

        let start: Date = null;
        let end: Date = null;
        if (this.viewBehaviour == "listview") {
            primitiveViewmode = WebcalendarTypes.WebCalendar_ViewTypes.list;
            start = this.listView.getCurrentScrollDate(); // nicht unbedingt nötig, wird wieter unten anders ermittelt
        }
        else {

            start = this.syncFusionCalendar.getCurrentSelectedDate("rangeStart");
            end = this.syncFusionCalendar.getCurrentSelectedDate("rangeEnd");

            if (typeof (start) == "number") {
                start = new Date(start);
            }
            if (!start || !start.setHours) {
                return;
            }
            start.setHours(0, 0, 0, 0);

        }



        let callbackData: any = null;


        switch (primitiveViewmode) {

            case WebcalendarTypes.WebCalendar_ViewTypes.list:
                let dates = this.listView.getUnloadedMonths(this.forceReload);
                if (this.forceReload) {
                    this.listView.resetNodes();
                    this.forceReload = false;
                }

                callbackData = dates;

                if (!dates.length) {
                    return;
                }
                else {
                    start = dates[0];
                    end = dates[dates.length - 1];
                    end = dojoDate.add(end, WebcalendarTypes.WebCalendar_ViewTypes.month, 1); // einen Monat am Schluss dazurechnen
                }
                break;
        }

        end.setHours(0, 0, 0, 0);

        let visibleStart = new Date(start.getTime());
        let visibleEnd = new Date(end.getTime());

        switch (primitiveViewmode) {
            case WebcalendarTypes.WebCalendar_ViewTypes.year:
                //// in Jahresansicht ist immer das komplette Jahr gefragt - evtl einen Tag +-
                //visibleStart.setMonth(0, 1);
                //visibleEnd.setMonth(11, 31);
                visibleStart = this.syncFusionCalendar.getCurrentSelectedDate("rangeStart");
                visibleEnd = this.syncFusionCalendar.getCurrentSelectedDate("rangeEnd");

                start = dojoDate.add(visibleStart, "day", -7);
                end = dojoDate.add(visibleEnd, "day", 7);
                break;
            case WebcalendarTypes.WebCalendar_ViewTypes.day:
                end.setHours(23, 59, 59);
                visibleEnd = new Date(end.getTime());
                break;
            case WebcalendarTypes.WebCalendar_ViewTypes.week:
                visibleStart = this.syncFusionCalendar.getCurrentSelectedDate("rangeStart");
                visibleEnd = this.syncFusionCalendar.getCurrentSelectedDate("rangeEnd");


                start = visibleStart;
                end = visibleEnd;
                break;

            case WebcalendarTypes.WebCalendar_ViewTypes.month:
                // Listenansicht wie Monat behandeln
                visibleStart.setDate(1);
                visibleEnd = dojoDate.add(visibleStart, primitiveViewmode, interval);
                visibleEnd = new Date(visibleEnd.getTime() - 1000); // bissl zrugg..1 sec

                let daysInEndMonth = dojoDate.getDaysInMonth(visibleEnd);

                visibleEnd.setDate(daysInEndMonth);

                // ein paar tage dazu damit die vormonatstage in der kalenderansicht auch mit daten befüllt werden
                start = dojoDate.add(visibleStart, "day", -7);
                end = dojoDate.add(visibleEnd, "day", 7);
                break;
        }

        if (primitiveViewmode == WebcalendarTypes.WebCalendar_ViewTypes.month) {

        }

        //console.log(this.id + ` start: ${start}, end: ${end}`);
        if (!visibleStart || !visibleStart || isNaN(visibleStart.valueOf())) {
            console.warn("invalid date?", "loadDataOfRange", start, end, visibleStart, visibleEnd);
            return;
        }
        if (this.syncFusionCalendar.scrollDate && this.viewBehaviour == "timeline") {
            //this.setUrlParameter("ds", this.syncFusionCalendar.scrollDate.valueOf().toString());
            this._delaySetUrlParameterDS(this.syncFusionCalendar.scrollDate);
        }
        else if (visibleStart && visibleStart.valueOf) {
            //this.setUrlParameter("ds", visibleStart.valueOf().toString());
            this._delaySetUrlParameterDS(this._actualSelectedDate ? this._actualSelectedDate : visibleStart);
        } else {
            //this.removeUrlParameter("ds");
            this._delaySetUrlParameterDS(null);
        }

        this._loadCalendarData({ start: start, end: end, callbackData: callbackData, targetItem: targetItem });
        this._ignoreDatePickerChange = true;
        this.datePicker.setDate(visibleStart);
        this.updateDatePicker(visibleStart, visibleEnd);

        setTimeout(lang.hitch(this, function () { this._ignoreDatePickerChange = false; }), 100);





        //console.log("visibleStart", visibleStart, "visibleEnd", visibleEnd);
        // ???
        //setTimeout(() => this.updateDatePicker(visibleStart, visibleEnd), 2000);
        // ???
    }

    private _urlParameterHandle_DS: any = null;
    // Wert des URL-Parameters "ds" beim Page-Load - in postCreate gecached.
    // setDefaultView liest aus diesem Cache statt direkt aus der URL, weil die URL bis dahin
    // schon durch initiale Scroll-Events überschrieben sein kann.
    private _restoredUrlDs: string = null;
    private _delaySetUrlParameterDS(newDate: Date) {
        if (this._urlParameterHandle_DS) {
            clearTimeout(this._urlParameterHandle_DS);
        }
        try {
            if (newDate && newDate.valueOf) {
                this._urlParameterHandle_DS = setTimeout(lang.hitch(this, this.setUrlParameter, "ds", newDate.valueOf().toString()), 400);
            } else {
                this._urlParameterHandle_DS = setTimeout(lang.hitch(this, this.removeUrlParameter, "ds"), 400);
            }
        } catch (ex) {

        }
    }

    private _ignoreDatePickerChange: boolean = false;

    private _setDefaultViewAttr(sDefaultView: string) {
        this.setDefaultView(sDefaultView as any);
    }

    private handleMainContainerVisibility(viewMode?: WebcalendarTypes.WebCalendar_ViewModes) {
        if (!viewMode) viewMode = this.calendarButtons.getSelectedViewMode();

        // ermitteln was gerade sichtbar ist
        let bIsCalendarVisible = !this.UiModder.domClass.contains(this.calendarView_container, "w3-hide");
        let bIsListviewVisible = !this.UiModder.domClass.contains(this.listView_container, "w3-hide");
        // Listview ist separat von Syncfusion. im Listviewmodus also den Hauptcontainer umschalten:
        switch (viewMode) {
            case WebcalendarTypes.WebCalendar_ViewModes.listView:
                if (bIsCalendarVisible) {
                    this._fadeOutNode(this.calendarView_container);
                }
                setTimeout(lang.hitch(this, this._fadeInNode, this.listView_container), 1001);

                break;

            default:
                if (bIsListviewVisible) {
                    this._fadeOutNode(this.listView_container);
                }
                setTimeout(lang.hitch(this, this._fadeInNode, this.calendarView_container), 1001);

                break;
        }
    }

    private _fadeOutNode(node: HTMLElement) {
        this.UiModder.domClass.add(node, "hidden");
        setTimeout(lang.hitch(this, function (node: HTMLElement) {
            this.UiModder.domClass.add(node, "w3-hide");
        }, node), 1000);
    }
    private _fadeInNode(node: HTMLElement) {
        this.UiModder.domClass.add(node, "hidden");
        this.UiModder.domClass.remove(node, "w3-hide");
        setTimeout(lang.hitch(this, function (node: HTMLElement) {
            this.UiModder.domClass.remove(node, "hidden");
        }, node), 10);
    }

    setDefaultView(sDefaultView: WebcalendarTypes.WebCalendar_ViewModes | string) {

        //console.log("setDefaultView", sDefaultView);

        let viewMode: WebcalendarTypes.WebCalendar_ViewModes = WebcalendarTypes.WebCalendar_ViewModes.day;
        if (sDefaultView) sDefaultView = sDefaultView.toUpperCase();

        let userDateTargetStr = this.getUrlParameterValue("date");
        if (userDateTargetStr) {
            let urlDate = new Date(userDateTargetStr);
            if (urlDate && urlDate.getTime && urlDate.getFullYear) {
                this.datePicker.setDate(urlDate);
                this.removeUrlParameter("date");
            }
        } else {


            // Aus dem in postCreate weggespeicherten Original-Wert lesen, nicht aktuell aus der URL.
            // Die URL kann zwischen Page-Load und hier durch SyncFusion's initiale Scroll-Events
            // bereits mit dem aktuellen Default-Datum (heute) überschrieben worden sein.
            let urlDateStr = this._restoredUrlDs;

            let urlDate: Date = null;
            if (urlDateStr) {
                let int = parseInt(urlDateStr);
                if (!isNaN(int)) {
                    urlDate = new Date(int);

                    if (urlDate && urlDate.getHours) {
                        this.datePicker.setDate(urlDate);

                        if (this.syncFusionCalendar)
                        {
                            //this.syncFusionCalendar.scheduleObject.selectedDate = urlDate;
                            this.syncFusionCalendar.scrollDate = urlDate;
                        }

                    }
                } else {
                    try {

                    } catch (ex) {

                    }
                    //this.removeUrlParameter("ds");
                    this._delaySetUrlParameterDS(null);
                }
            }
        }

        switch (sDefaultView as any) {
            case WebcalendarTypes.WebCalendar_ViewModes.listView.toUpperCase():
                viewMode = WebcalendarTypes.WebCalendar_ViewModes.listView;
                //this.listView.setup([urlDate ? urlDate : new Date()], urlDate ? urlDate : new Date());
                break;
            case "WEEK":
                viewMode = WebcalendarTypes.WebCalendar_ViewModes.week;
                break;
            case "YEAR":
                viewMode = WebcalendarTypes.WebCalendar_ViewModes.year;
                break;
            case "MONTH":
                viewMode = WebcalendarTypes.WebCalendar_ViewModes.month;
                break;
            case "DAY":
                viewMode = WebcalendarTypes.WebCalendar_ViewModes.day;
                break;
            case "THREEDAYS":
            case "3DAYS":
                viewMode = WebcalendarTypes.WebCalendar_ViewModes.threeDays;
                break;
            case "TWOWEEKS":
            case "2WEEKS":
                viewMode = WebcalendarTypes.WebCalendar_ViewModes.twoWeeks;
                break;

            case "TIMELINEDETAIL":
                viewMode = WebcalendarTypes.WebCalendar_ViewModes.timelineDetail;
                break;

            case "TIMELINEOVERVIEW":
                viewMode = WebcalendarTypes.WebCalendar_ViewModes.timelineOverview;
                break;
            case "TIMELINEYEAR":
                viewMode = WebcalendarTypes.WebCalendar_ViewModes.timelineYear;
                break;
            case "TIMELINEDAY":
                viewMode = WebcalendarTypes.WebCalendar_ViewModes.timelineDay;
                break;
        }



        this._onCalendarButtonsNavigation(viewMode);

        if (this.calendarButtons) {
            this.calendarButtons.setCurrentView(viewMode);
        }

        //this.handleMainContainerVisibility(viewMode);


        return;

    }
    /**
     *
     * @param bShowDatagroups
     * @param bVolatileMode Wenn true, wird die Einstellung nicht in die lokalen Usersettings zurückgespeichert
     */
    showDataGroups(bShowDatagroups: boolean, bVolatileMode?: boolean) {

        if (!bVolatileMode) {
            if (!bShowDatagroups) this.toggleCb(this.cbShowEmptyGroups, this.btnShowEmptyGroups, false);
            this.toggleCb(this.cbEnableDatagrouping, this.btnEnableDatagrouping, bShowDatagroups || this.cbShowEmptyGroups.checked, this.cbShowEmptyGroups.checked);
        }
        // this.onChange_enableDatagrouping();
        if (this.syncFusionCalendar){
            this.syncFusionCalendar.removeAllGroupingResources();
            if (this.cbShowEmptyGroups.checked) {
                this.syncFusionCalendar.showAllGroups(bShowDatagroups);
            } else {
                this.syncFusionCalendar.showGroups(bShowDatagroups);
            }
        }

        this.listView?.showGroups(bShowDatagroups);
        if (this.syncFusionCalendar){
            if (!bVolatileMode) {
                try {
                    if (!this.syncFusionCalendar.isTimeLineMode()) {
                        let userSetting = this.getUserCalendarSettingsFromStore();
                        userSetting.showDataGroups = bShowDatagroups;
                        this.saveUserSettingsToStorage(userSetting);
                    }
                } catch (ex) {

                }
            }
        }
    }

    showEmptyDataGroups(bShowEmptyGroups: boolean, bVolatileMode?: boolean) {

        if (!bVolatileMode) {
            this.toggleCb(this.cbShowEmptyGroups, this.btnShowEmptyGroups, bShowEmptyGroups);

            this.toggleCb(this.cbEnableDatagrouping,
                this.btnEnableDatagrouping,
                this.cbEnableDatagrouping.checked || this.cbShowEmptyGroups.checked,
                this.cbShowEmptyGroups.checked);
        }


        if (typeof (this.selectedCalendarConfig?.ref_web_calendar?.bDataGroupingAvailable) == "boolean") {
            this.hideNode(this.data_grouping_container, this.selectedCalendarConfig.ref_web_calendar.bDataGroupingAvailable != true);
        }

        if (this.viewBehaviour == "calendar") {
            if (this.syncFusionCalendar){
                this.syncFusionCalendar.removeAllGroupingResources();
                this.syncFusionCalendar.showAllGroups(bShowEmptyGroups);
            }
        }

        if (this.syncFusionCalendar){
            if (!bVolatileMode) {
                try {
                    if (!this.syncFusionCalendar.isTimeLineMode()) {
                        let userSetting = this.getUserCalendarSettingsFromStore();
                        userSetting.showEmptyGroups = bShowEmptyGroups;
                        this.saveUserSettingsToStorage(userSetting);
                    }
                } catch (ex) {

                }
            }
        }
    }

    private _loadCalendarResources(calendarId: string): void {
        if (this.isTimelineModeAvailable()) {


            let url = window.appRoot + this.__resourcesDataUrl;

            let params: any = {
                "jsonData": JSON.stringify({
                    CalendarId: calendarId,
                    LoadDataSource: false
                })
            };

            if (this.__resourcesDataFunction != null) {
                params["customFunctionName"] = this.__resourcesDataFunction;
            }

            this._getResourcesDataRequest = this.RequestManager.post(
                url,
                params,
                lang.hitch(this, this._onGetResourcesData_Response),
                lang.hitch(this, this._onGetResourcesData_Error)
            );
        }
    }
    private _setFiltersAttr(filtersArray: Array<WebcalendarTypes.WebCalendar_FilterAssignment>): void {
        this.setFilters(filtersArray);
    }
    private setFilters(filtersArray: Array<WebcalendarTypes.WebCalendar_FilterAssignment>): void { // Array of filter ID's
        let oneFilterselected: boolean = false;

        // alle übrigend container und labels entfernen
        domConstruct.empty(this.filterContainerList);

        // Wenn nur ein Filter vorhanden ist, dann soll das Filterpane nicht angezeigt werden
        this.hideNode(this.filterContainer, filtersArray.length <= 1);


        if (filtersArray.length > 1 || this.userProperties.calendarConfigs.length > 1 || this.filterPaneHasCustomContent == true) {
            this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.filterPane);

        } else {
            this.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.filterPane);
        }

        this.subfilterReg = {};
        this.filterReg = {};
        let userSettings = this.getUserCalendarSettingsFromStore();

        // neue checkboxen hinzufügen
        for (var k = 0; k < filtersArray.length; k++) {
            let htFilter: WebcalendarTypes.WebCalendar_FilterAssignment = filtersArray[k];

            let filterContainer: HTMLElement = domConstruct.create("div", {
                className: "filterEntryContainer"
            }, this.filterContainerList);

            let filterGroupRow: HTMLElement = domConstruct.create("div", {
                className: "filterGroupRow"
            }, filterContainer);


            let button: HTMLElement = domConstruct.create("button", {
                className: "buttonBase filterButton",
                innerHTML: htFilter.ref_web_calendar_filter.description
            }, filterGroupRow);


            on(button, "click", lang.hitch(this, this._onClick_ToggleFilter, htFilter.ID));

            let bActivate: boolean = false;
            if (htFilter.is_active && htFilter.is_active == true) {
                bActivate = true;
            }

            try {
                let activatedIndex = userSettings.selectedFilterIds.indexOf(htFilter.ID);
                let deactivatedIndex = userSettings.deselectedFilterIds.indexOf(htFilter.ID);
                if (activatedIndex != -1) {
                    bActivate = true;
                    if (deactivatedIndex != -1) userSettings.deselectedFilterIds.splice(deactivatedIndex, 1);
                } else if (deactivatedIndex != -1) {
                    bActivate = false;
                }
            } catch (ex) {

            }

            if (bActivate) {
                domClass.add(button, "active");
                oneFilterselected = true
            }




            if (htFilter.ref_web_calendar_filter.coloration) {
                let bgColor = ColorHelpers.getHexColorFromProperty(htFilter.ref_web_calendar_filter.coloration, "BG");
                let txtColor = ColorHelpers.getHexColorFromProperty(htFilter.ref_web_calendar_filter.coloration, "TXT");

                filterContainer.style.setProperty("--filterColor", bgColor);

            }

            let filterReg: FilterEntry = {
                htFilter: htFilter,
                ID: htFilter.ID,
                checked: bActivate,
                buttonNode: button,
                node: filterContainer,
                buttonContainer: filterGroupRow,
                subfiltersSectionNode: null,
                subfiltersContainerNode: null,
                subfilters: []
            };
            this.filterReg[htFilter.ID] = filterReg;

            if (htFilter.EL_subfilters && htFilter.EL_subfilters.length) {
                this._createSubfilters(this.filterReg[htFilter.ID]);
                this.hideNode(this.filterContainer, false); // Filterbereich doch wieder einblenden, falls er bei nur einem Filter vorher ausgeblendet war

                // prüfen: ist gar nichts gewählt?
                let activeSubs = filterReg.subfilters.filter(entry => entry.checked === true);
                if (!activeSubs.length) {
                    this._onClick_ToggleFilter(filterReg.ID, false);
                }
            }



        }

        let filterKeys = Object.keys(this.filterReg);
        if (oneFilterselected == false && filterKeys.length == 1) {
            this._onClick_ToggleFilter(this.filterReg[filterKeys[0]].ID, true)

        } else if (filterKeys.length == 0) {
            alert("no filters available!");
            return;
        }

        this.saveUserSettingsToStorage(userSettings);

        this.removeToast("noFilterSelected");

        this.searchPanel.setup(this.getActiveFilterIDs(), this.getCurrentSelectedCalendar().ID, this.getSelectedResourceGroups());
        this.set("loadingRequirement", "filters", 1);
    }

    private _createSubfilters(parentReg: FilterEntry) {

        if (!parentReg) return;


        let htFilter = parentReg.htFilter;

        let ctrlContainer = domConstruct.create("button", {
            id: "",
            className: "buttonBase expanderControl"
        }, parentReg.buttonContainer);
        on(ctrlContainer, "click", lang.hitch(this, this._onClick_ToggleExpandSubfilterSection, parentReg));


        let subFilterSection: HTMLElement = domConstruct.create("div", {
            id: "",
            className: "subfilterSection"
        }, parentReg.node);

        if (htFilter.ref_web_calendar_filter.coloration) {
            let bgColor = ColorHelpers.getHexColorFromProperty(htFilter.ref_web_calendar_filter.coloration, "BG");
            if (bgColor) {
                subFilterSection.style.setProperty("--parentfilterColor", bgColor);
            }
        }


        let subfilterContainer = domConstruct.create("div", {
            id: "",
            className: "subfilterContainer"
        }, subFilterSection);

        parentReg.subfiltersSectionNode = subFilterSection;
        parentReg.subfiltersContainerNode = subfilterContainer;

        let selectAllBtn = this.UiModder.domConstruct.create("button", {
            className: "buttonBase filterToggleAll",
        }, parentReg.buttonContainer, 1);

        on(selectAllBtn, "click", lang.hitch(this, this._onClick_ToggleAllSubFilters, parentReg));

        let userSettings = this.getUserCalendarSettingsFromStore();

        htFilter.EL_subfilters.sort((entryA, entryB) => { return entryA.order - entryB.order; })
        for (let htSubfilter of htFilter.EL_subfilters) {
            let subfilterButton = new Button();
            subfilterButton.setLabel(htSubfilter.ref_web_calendar_filter.description);
            //subfilterCB.setType("togglebutton");
            //subfilterCB.setColorationFromProperty(htSubfilter.ref_web_calendar_filter.coloration);

            subfilterButton.placeAt(subfilterContainer);
            //subfilterCB.setValue(htSubfilter.is_active == true, true);
            subfilterButton.on("click", lang.hitch(this, this._onChange_Subfilter, htSubfilter.ID));

            subfilterButton.setColorationFromProperty(htSubfilter.ref_web_calendar_filter.coloration);

            let isPreselected = htSubfilter.is_active == true;



            if (userSettings && userSettings) {
                try {
                    let activatedIndex = userSettings.selectedSubfilterIds.indexOf(htSubfilter.ID);
                    let deactivatedIndex = userSettings.deselectedSubfilterIds.indexOf(htSubfilter.ID);
                    if (activatedIndex != -1) {
                        isPreselected = true;
                        if (deactivatedIndex != -1) userSettings.deselectedFilterIds.splice(deactivatedIndex, 1);
                    } else if (deactivatedIndex != -1) {
                        isPreselected = false;
                    }
                } catch (ex) {

                }
            }

            subfilterButton.setClassesEx({ defaultClasses: "subfilterButton" });
            if (isPreselected) subfilterButton.setClassesEx("active");

            this.subfilterReg[htSubfilter.ID] = {
                ID: htSubfilter.ID,
                button: subfilterButton,
                checked: isPreselected,
                htFilter: htSubfilter,
                parentFilterID: htFilter.ID
            };

            parentReg.subfilters.push(this.subfilterReg[htSubfilter.ID]);
        }

        this._handleParentFilterStyle(htFilter.ID);
    }

    private _onClick_ToggleAllSubFilters(registryEntry: FilterEntry) {

        if (registryEntry && registryEntry.subfilters?.length && registryEntry.checked) {
            for (let subfilter of registryEntry.subfilters) {
                this._onChange_Subfilter(subfilter.ID, true);
            }
        }
    }
    private _onClick_ToggleExpandSubfilterSection(registryEntry: FilterEntry) {
        this.UiModder.domClass.toggle(registryEntry.subfiltersSectionNode, "expanded");
    }

    private _onClick_ToggleResourceGroup(registryEntry: WebcalendarTypes.WebCalendarResourceCheckboxes) {

        let currentlySelected = this.getSelectedResourceGroups();

        let targetCb = registryEntry.checkbox;
        let targetBtn = registryEntry.button;

        registryEntry.selected = !registryEntry.selected;

        targetCb.checked = registryEntry.selected;

        this.UiModder.domClass.toggle(targetBtn, "active", registryEntry.selected);


        this.applyResourceGroup(targetCb.checked, targetCb.value);
    }

    private getSelectedResourceGroups(): Array<string> {
        let result = [];
        for (let entry of this.resourceGroupRegistry) {
            if (entry.selected) {
                result.push(entry.resourceData.DescriptorId);
            }
        }

        return result;
    }

    private applyResourceGroup(bActive: boolean, resourceGroupID: string, resourceConfig?: WebcalendarTypes.WebCalendarResourceData<any>) {

        if (this.cbShowEmptyGroups.checked) {
            //this.toggleCb(this.cbShowEmptyGroups, this.btnShowEmptyGroups, false);
            this.showEmptyDataGroups(false);
        }
        if (this.cbEnableDatagrouping.checked) {
            //this.toggleCb(this.cbEnableDatagrouping, this.btnEnableDatagrouping, false);
            this.showDataGroups(false);
        }

        let selectedResources = this.getSelectedResourceGroups();
        let resourceStillActive = selectedResources.indexOf(resourceGroupID) != -1;

        if (bActive) {
            if (this._ressourcesQueue.indexOf(resourceGroupID) == -1) {
                if (this._ressourcesDataTimeout) clearTimeout(this._ressourcesDataTimeout);
                this._ressourcesQueue.push(resourceGroupID);
                this._ressourcesDataTimeout = setTimeout(lang.hitch(this, this.loadResourcesSourceData), 1500);
            }
        } else {

            let index = this._ressourcesQueue.indexOf(resourceGroupID);
            if (index >= 0) this._ressourcesQueue.splice(index, 1);

            this.syncFusionCalendar.removeResourceGroup(resourceGroupID);
        }
    }

    private isTimelineModeAvailable(): boolean {
        if (this.hasFeature("Webcalendar/Timeline")) {
            let currentCalendar = this.getCurrentSelectedCalendar();
            if (currentCalendar?.b_allow_view_timelineday ||
                currentCalendar?.b_allow_view_timelinedetail ||
                currentCalendar?.b_allow_view_timelineyear ||
                currentCalendar?.b_allow_view_timelineoverview) {
                return true;
            }
        }
        return false;
    }
    private isListViewModeAvailable(): boolean {
        if (this.hasFeature("Webcalendar/listview")) {
            let currentCalendar = this.getCurrentSelectedCalendar();
            if (currentCalendar?.b_allow_view_list !== false) {
                return true;
            }
        }
        return false;
    }
    private _ressourcesDataTimeout: number = null;
    private _ressourcesQueue: Array<string> = [];
    private loadResourcesSourceData() {
        if (this.isTimelineModeAvailable()) {
            let targetValues = this._ressourcesQueue;
            this._ressourcesQueue = [];

            if (targetValues.length == 0) return;

            this.syncFusionCalendar.showLoadingScreen("Resources", TranslationHelpers.tryTranslate("WebCalendar_Resources_LoadingText", true));
            this.syncFusionCalendar.setEventsDataLock(true); // damit wird das SetEvents unterbrochen, falls GetFilterdata schneller geladen hat
            let cal = this.getCurrentSelectedCalendar();
            let url = window.appRoot + this.__resourcesDataUrl;
            let params: any = {
                "jsonData": JSON.stringify({ CalendarId: cal?.ID, LoadDataSource: true, DescriptorIds: targetValues })
            };
            this._getResourcesDataSourceRequest = this.RequestManager.post(
                url,
                params,
                lang.hitch(this, this._onGetResourcesDataSource_Response),
                lang.hitch(this, this._onGetResourcesDataSource_Error)
            );
        }

    }

    private _onGetResourcesDataSource_Response(response: any) {
        this._getResourcesDataSourceRequest = null;

        let resourcesDataResponse: Array<WebcalendarTypes.WebCalendarResourceData<any>>;

        if (this.isJSON(response)) {
            resourcesDataResponse = JSON.parse(response);
        } else if (response.Exception == true) {
            alert("ERROR loading filterData: details in the console")
            console.error(response);
            return;
        } else {
            resourcesDataResponse = response;
        }

        this.syncFusionCalendar.setTimelineResources(resourcesDataResponse);

        // falls dieses callback erst nach dem getfilterdata daherkommt, muss der Scheduler die Events nochmal frisch mappen:
        //if( this.)
    }

    private _onGetResourcesDataSource_Error(err): void {
        this._getResourcesDataSourceRequest = null;
        alert(err.Message);
        console.error(err);
        this.StandbyStop();
    }

    private _onClick_ToggleFilter(filterID: string, targetState?: boolean) {
        let reg = this.filterReg[filterID];
        let isChecked = reg.checked;
        if (typeof (targetState) != "boolean") targetState = !isChecked;

        // wird aktiviert, und sind alle Subfilter inaktiv? dann diese mitaktivieren
        if (reg.subfilters.length && targetState == true) {
            let activeSubs = reg.subfilters.filter(entry => entry.checked == true);
            if (!activeSubs.length) {
                for (let subfilter of reg.subfilters) {
                    this._onChange_Subfilter(subfilter.ID, true);
                }
            }
        }

        if (reg.checked != targetState) {
            reg.checked = targetState;

            this.UiModder.domClass.toggle(reg.buttonNode, "active", reg.checked);

            this._onChange_Filter();
        }
        //this.syncFusionCalendar.showLoadingScreen("FilterData");
    }


    private _onChange_Filter() {
        this.UiModder.domClass.toggle(this.syncFusionCalendar.syncFusionContainer, "blur w3-disabled", true);
        //this.UiModder.domClass.toggle(this.listView_container, "blur w3-disabled", true);
        this.listView.invalidateData();

        let filters: Array<string> = this.getActiveFilterIDs();
        let inactiveFilter: Array<string> = this.getInactiveFilterIDs();

        if (filters?.length == 0) {
            this.showToast({
                title: this.translate("WebCalendar__Toast_NoFilterSelected"),
                iconClass: "fas fa-filter warningTXT",
                ID: "noFilterSelected",
                timeout: "permanent",
                options: {
                    onClick: lang.hitch(this, this._highlightFilterButtons)
                }
            });

            this._highlightFilterButtons();
            return;

        }

        if (filters?.length) {
            this.removeToast("noFilterSelected");
            this.searchPanel.setup(this.getActiveFilterIDs(), this.getCurrentSelectedCalendar().ID, this.getSelectedResourceGroups());
        }

        this.loadDataOfRange_Delayed();


        try {
            let userSettings = this.getUserCalendarSettingsFromStore();
            userSettings.selectedFilterIds = filters;
            userSettings.deselectedFilterIds = inactiveFilter;
            this.saveUserSettingsToStorage(userSettings);
        } catch (ex) {

        }
    }

    private _onChange_Subfilter(subFilterID: string, targetState?: boolean) {
        let reg = this.subfilterReg[subFilterID];

        if (typeof (targetState) != "boolean") {
            targetState = reg.checked != true;
        }

        if (reg.checked != targetState) {
            this.listView.invalidateData();


            reg.checked = targetState;

            let isChecked = reg.checked == true;
            if (isChecked) reg.button.setClassesEx("active");
            else reg.button.setClassesEx(null, "active");


            this._handleParentFilterStyle(reg.parentFilterID);

            let parentReg = this.filterReg[reg.parentFilterID];

            // prüfen: ist gar nichts mehr gewählt?
            let activeSubs = parentReg.subfilters.filter(entry => entry.checked === true);
            if (!activeSubs.length) {
                this._onClick_ToggleFilter(parentReg.ID, false);
            } else {
                if (parentReg.checked) {
                    this.loadDataOfRange_Delayed();
                } else {
                    this._onClick_ToggleFilter(parentReg.ID, true);
                }
            }

            try {
                let subfilters = this.getActiveSubfilterIDs();
                let subfiltersInactive = this.getInactiveSubfilterIDs();
                let userSettings = this.getUserCalendarSettingsFromStore();
                userSettings.selectedSubfilterIds = subfilters;
                userSettings.deselectedSubfilterIds = subfiltersInactive;
                this.saveUserSettingsToStorage(userSettings);
            } catch (ex) {

            }
        }
    }

    private _handleParentFilterStyle(parentFilterID: string) {
        let parent = this.filterReg[parentFilterID];
        if (!parent) return;

        // prüfen, ob es noch irgendeinen aktiven Subfilter in dieser Gruppe gibt.
        // ansonsten ist de facto die ganze Gruppe inaktiv, das sollte der User mitbekommen
        let bGroupHasActiveSubs = false;
        let bGroupHasInactiveSubs = false;
        for (let value in this.subfilterReg) {
            let subfilter = this.subfilterReg[value];
            if (subfilter.parentFilterID == parent.ID) {
                if (subfilter.checked == true) {
                    bGroupHasActiveSubs = true;

                } else {
                    bGroupHasInactiveSubs = true;
                }

                if (bGroupHasActiveSubs && bGroupHasInactiveSubs) break;
            }
        }

        this.UiModder.domClass.toggle(parent.node, "noActiveChildren", !bGroupHasActiveSubs);
        this.UiModder.domClass.toggle(parent.node, "partlyActive", bGroupHasActiveSubs && bGroupHasInactiveSubs);

    }

    private _highlightFilterButtons() {
        this.expandPane(WebcalendarTypes.WebCalendar_DefaultPanes.filterPane);
        this.filterContainer.scrollIntoView({ behavior: "smooth", block: "nearest" });
        let elements = this.filterContainer.getElementsByClassName("filterButton");
        for (let i = 0; i < elements.length; i++) {
            let btn = elements[i];

            setTimeout(lang.hitch(this, this.UiModder.domClass.add, btn, "warning"), 100 * i);
            setTimeout(lang.hitch(this, this.UiModder.domClass.remove, btn, "warning"), 1500 + 100 * i);
        }

    }

    private _getActiveFiltersAttr(): Array<string> {
        return this.getActiveFilterIDs();
    }
    private getActiveFilterIDs(subFilters?: boolean): Array<string> {

        if (subFilters === true) {
            return this.getActiveSubfilterIDs();
        }
        let selectedFilterIds: Array<string> = [];
        for (let key in this.filterReg) {
            let reg = this.filterReg[key];
            if (reg.checked == true) {
                selectedFilterIds.push(reg.ID);
            }
        }

        return selectedFilterIds;
    }
    private getActiveSubfilterIDs(): Array<string> {

        let selectedFilterIds: Array<string> = [];

        for (let keyvalue in this.subfilterReg) {
            let reg = this.subfilterReg[keyvalue];

            if (reg.checked == true) {
                selectedFilterIds.push(reg.ID);
            }
        }

        return selectedFilterIds;
    }

    private getInactiveFilterIDs(): Array<string> {
        let deselectedFilterIds: Array<string> = [];
        for (let key in this.filterReg) {
            let reg = this.filterReg[key];
            if (reg.checked != true) {
                deselectedFilterIds.push(reg.ID);
            }
        }
        return deselectedFilterIds;
    }
    private getInactiveSubfilterIDs(): Array<string> {
        let deselectedFilterIds: Array<string> = [];
        for (let key in this.subfilterReg) {
            let reg = this.subfilterReg[key];
            if (reg.checked != true) {
                deselectedFilterIds.push(reg.ID);
            }
        }
        return deselectedFilterIds;
    }

    setMainConfig(config: WebcalendarTypes.WebCalendarMainPropertiesConfig) {

        if (typeof (config?.enableLocalUserSettings) == "boolean") {
            this._enableLocalUserSettings = config.enableLocalUserSettings;
        }

        if (config.userProperties) {
            this.setUserPropertiesConfig(config.userProperties);
        }

        if (config.itemDetails) {

            if (typeof (config.itemDetails.customItemClickFunction) == "function") {
                this.setItemClickFunction(config.itemDetails.customItemClickFunction);
            } else {
                this.setItemClickFunction(this.openDefaultDetailView); // default
            }
        }

        if (config.resourceClickFct) {
            this.resourceClickFunction = config.resourceClickFct;
        }
        if (typeof (config.gridDoubleClickFct) == "function") {
            this.gridDoubleClickFunction = config.gridDoubleClickFct;
        }


        if (config.filterData) {
            //if (config.filterData.requestUrl) {
            //    this.__filterDataUrl = config.filterData.requestUrl;
            //}

            if (config.filterData.requestItemLimit > 2) this.__requestItemLimit = config.filterData.requestItemLimit;

            if (config.filterData.customFunctionName) {
                this.__filterDataFunction = config.filterData.customFunctionName;
            }
            if (config.filterData.additionArgs) {
                this.__filterDataAdditionArgs = config.filterData.additionArgs;
            }
        }

        if (config.defaultDisplaySettings) {
            let userData = this.getUserCalendarSettingsFromStore();

            let dspSettings = config.defaultDisplaySettings;

            if (userData) {
                try {
                    if (userData.showEndTime != null) dspSettings.b_show_end_time = userData.showEndTime;
                    if (userData.showDataGroups != null) dspSettings.b_show_datagroups = userData.showDataGroups;
                    if (userData.showEmptyGroups != null) dspSettings.b_show_empty_groups = userData.showEmptyGroups;
                    if (userData.showTimeIndicator != null) dspSettings.b_show_timeindicator = userData.showTimeIndicator;
                    if (userData.autoAdjust != null) dspSettings.autoAdjustToDisplay = userData.autoAdjust;

                    if (typeof (userData.scaleFactor) == "number") {
                        this._currentZoomFactor = userData.scaleFactor;
                    }
                } catch (ex) {

                }
            }

            if (dspSettings.b_show_end_time === true || dspSettings.b_show_end_time === false) {
                this.__displaySettings.b_show_end_time = dspSettings.b_show_end_time;
            }

            if (dspSettings.hideColumnHead === true || dspSettings.hideColumnHead === false) {
                this.__displaySettings.hideColumnHead = dspSettings.hideColumnHead;
            }

            if (dspSettings.b_show_timeindicator === true || dspSettings.b_show_timeindicator === false) {
                this.__displaySettings.b_show_timeindicator = dspSettings.b_show_timeindicator;
            }

            if (dspSettings.b_show_datagroups === true || dspSettings.b_show_datagroups === false) {
                this.__displaySettings.b_show_datagroups = dspSettings.b_show_datagroups;
            }

            if (dspSettings.b_show_empty_groups === true || dspSettings.b_show_empty_groups === false) {
                this.__displaySettings.b_show_empty_groups = dspSettings.b_show_empty_groups;
            }

            if (dspSettings.autoAdjustToDisplay === true || dspSettings.autoAdjustToDisplay === false) {

                this.__displaySettings.autoAdjustToDisplay = dspSettings.autoAdjustToDisplay;
                this.cbAutoAdjust.checked = dspSettings.autoAdjustToDisplay;
            }

        }

        if (config.quickSearchSettings) {
            this.setQuickSearchConfig(config.quickSearchSettings);
        }

        if (typeof (config.enableQuickSearch) == "boolean") {
            this.hideNode(this.quickSearchContainer, config.enableQuickSearch != true || !this.hasFeature("Webcalendar/Quicksearch"));
        }

        this.currentPreConfig = config;

    }

    setQuickSearchConfig(config: any) {
        this.__searchSettings = config.quickSearchSettings;
        this.hideNode(this.searchPane, this.__searchSettings);

    }

    expandPane(name: string | WebcalendarTypes.WebCalendar_DefaultPanes) {
        let node = this.getPaneNodeByName(name, true);

        if (node) {
            this._toggleSidebarSection(node, true);
        }
    }

    setItemClickFunction(callback: Function): void {
        this.itemClickFunction = callback;
    }

    loadData() {
        this._loadDataOfRange();
    }

    reloadData(item?: WebcalendarTypes.WebCalendarItemData_Default, delay?: number) {
        this.forceReload = true;
        this._loadDataOfRange(item, delay);
    }

    setUserPropertiesConfig(config: WebcalendarTypes.WebCalendarUserPropertiesConfig) {
        this.__userPropConfig = config;
    }

    //refreshCalendarButtonLabels() {
    //    let visibleDates = this.syncFusionCalendar.getVisibleDates();

    //    if (visibleDates.length > 1) {
    //        let firstDateVISIBLE = visibleDates[0];
    //        let lastDateVISIBLE = visibleDates[visibleDates.length - 1];

    //        let firstDateRANGE = this.syncFusionCalendar.earliestDate;
    //        let lastDateVRANGE = this.syncFusionCalendar.latestDate;

    //        this.calendarButtons.setRangeLabels(this.syncFusionCalendar.scheduleObject.selectedDate.toLocaleDateString(), firstDateRANGE.toLocaleDateString(), lastDateVRANGE.toLocaleDateString());
    //    }
    //}

    private processConfigColors(colorationAttributesArray: Array<WebcalendarTypes.WebCalendar_ColorAttribute>): void {
        //console.debug("webcalendar _setColorationAttributesAttr", colorationAttributesArray);
        domConstruct.empty(this.colorationSelectContainer);

        this.colorationAttrRegistry = []; // Array<{entity_calssname: string,  tmp_class_printname:string, colorAttributes : Array<colorAttributes>}>

        for (var colorationAttribute of colorationAttributesArray) { ////: Array<{ classname: string, ID: string, description: string, entity_classname: string, tmp_class_printname: string }>

            var objExists = false;

            for (var registryObj of this.colorationAttrRegistry) {  // Array<{entity_calssname: string,  tmp_class_printname:string, colorAttributes : Array<{ classname: string, ID: string, description: string, entity_classname: string, tmp_class_printname: string }>}>

                //prüfen ob für die entity_classname schon ein objekt existiert
                if (registryObj.entity_classname == colorationAttribute.entity_classname) {

                    objExists = true;

                    let colorIndex: number = -1;
                    for (let i = 0; i < registryObj.colorAttributes.length; i++) {
                        if (registryObj.colorAttributes[i].ID == colorationAttribute.ID) {
                            colorIndex = i;
                        }
                    }

                    if (colorIndex < 0) {
                        // wenn das colorAttr noch nicht im array ist - push
                        registryObj.colorAttributes.push(colorationAttribute);
                    } else {
                        // wenn es schon gibt (sollte nicht) - überschreiben
                        registryObj.colorAttributes[colorIndex] = colorationAttribute;
                    }
                }
            }

            if (objExists === false) {
                this.colorationAttrRegistry.push(
                    {
                        entity_classname: colorationAttribute.entity_classname,
                        tmp_class_printname: colorationAttribute.tmp_class_printname,
                        colorAttributes: Array(colorationAttribute)
                    })
            }

        }


        // Jetzt haben wir die Registry nach entity_class.
        // Jetzt pro Klass eine Selectbox bauen

        this._createColorationSelects();
        this.set("loadingRequirement", "colorationAttributes", 1);
    }

    private _createColorationSelects(): void {
        // pro Klass eine Selectbox bauen
        this.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane);

        let selectCounter: number = 0;

        let settings = this.getUserCalendarSettingsFromStore();


        if (this.colorationAttrRegistry && this.colorationAttrRegistry.length) {

            let optionsCounter: number = 0;
            this._colorationSelectList = { selectNodes: [], classNames: [] };

            for (var j = 0; j < this.colorationAttrRegistry.length; j++) {

                let registryObj: colorAttributeRegistryObj = this.colorationAttrRegistry[j];
                let style: string = "";

                let colorSelectDiv = domConstruct.create("div", {
                    className: "w3-hide colorationContainer",
                    "data-entity-class": registryObj.entity_classname
                }, this.colorationSelectContainer, "last");

                domConstruct.create("div", {
                    "innerHTML": registryObj.tmp_class_printname,
                    className: "colorationSelectLabel",
                }, colorSelectDiv);

                let selectNode: HTMLSelectElement = domConstruct.create("select", {
                    "class": "w3-input border colorationSelector_select round",
                    "data-entity-class": registryObj.entity_classname
                }, colorSelectDiv) as HTMLSelectElement;


                on(selectNode, "change", lang.hitch(this, this._onColorationAttributeChanged, registryObj.entity_classname));


                let presetValue = null;
                if (settings?.colors?.length) {
                    for (let entry of settings.colors) {
                        if (entry.entity_classname == registryObj.entity_classname) {
                            presetValue = entry.value;
                            break;
                        }
                    }
                }

                for (var i = 0; i < registryObj.colorAttributes.length; i++) {
                    var colorAttr: WebcalendarTypes.WebCalendar_ColorAttribute = registryObj.colorAttributes[i];
                    let option: HTMLOptionElement = domConstruct.create("option", {
                        value: colorAttr.ID,
                        innerHTML: colorAttr.description,
                    }, selectNode, "last") as HTMLOptionElement;
                    optionsCounter++;

                    if (presetValue) option.selected = colorAttr.ID == presetValue;
                }

                if (presetValue) selectNode.value = presetValue;

                this._colorationSelectList.selectNodes.push(selectNode);
                this._colorationSelectList.classNames.push(registryObj.entity_classname);

                if (registryObj.colorAttributes.length > 1) { // Nur select samt Überschrift erzeugen wenn überhaupt mehr als 1 Option wählbar
                    this.hideNode(colorSelectDiv, false);
                    selectCounter++;
                }
            }

            if (selectCounter > 0) {
                this.showPane(WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane);

            } else if (this.colorationAttrRegistry.length == 1) {
                this.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.colorationPane);
                let registryObj: colorAttributeRegistryObj = this.colorationAttrRegistry[0];
                this.syncFusionCalendar.addColorToRegistry(registryObj.colorAttributes[0].ID, registryObj.entity_classname);
                this.listView.addColorToRegistry(registryObj.colorAttributes[0].ID, registryObj.entity_classname);
            }
            this._onColorationAttributeChanged();
            if (this.syncFusionCalendar) {
                this.syncFusionCalendar.redrawEvents();
            }
        } else {
            if (this.syncFusionCalendar) {
                this.syncFusionCalendar.redrawEvents();
            }
        }
    }

    private _onColorationAttributeChanged(classname?: string): void {

        var colorStorage = [];
        let settings = this.getUserCalendarSettingsFromStore();
        if (settings) settings.colors = [];

        this._colorationSelectList.selectNodes.forEach(select => {

            let selectClassvalue = select.attributes.getNamedItem("data-entity-class");
            if (classname && selectClassvalue.value == classname) {
                this.syncFusionCalendar.addColorToRegistry(select["value"], classname);
                this.listView.addColorToRegistry(select["value"], classname);
            } else if (!classname) {
                if (this.syncFusionCalendar) {
                    this.syncFusionCalendar.addColorToRegistry(select["value"], selectClassvalue.value);
                    this.listView.addColorToRegistry(select["value"], selectClassvalue.value);
                }
            }


            if (settings) {
                settings.colors.push({
                    entity_classname: selectClassvalue.value,
                    value: select["value"]
                })

                this.saveUserSettingsToStorage(settings);
            }

        });

        //var selectList: HTMLCollection = this.colorationSelectContainer.getElementsByClassName("colorationSelector_select");

        //for (var k = 0; k < selectList.length; k++) {
        //    this.calendar.itemColorationAttribute[(<HTMLInputElement>selectList[k]).dataset["entity_classname"]] = (<HTMLInputElement>selectList[k]).value

        //}

        //this.calendar._refreshItemsRendering();
    }

    private _onChange_YearViewMonthCount() {
        this._setYearViewParameters();
    }
    private _onChange_YearViewStartMonth() {
        this._setYearViewParameters();
    }

    private _setYearViewParameters() {
        let currentView = this.getCurrentViewMode();
        let newSettings = this.syncFusionCalendar.setYearViewParameters({
            firstMonthOfYear: this.inputYearViewStartMonth.getValue(),
            monthsCount: this.inputYearViewMonthCount.getValue()
        });

        if (newSettings) {
            let settings = this.getUserCalendarSettingsFromStore();
            if (settings) {
                settings.YearViewMonthsCount = newSettings.monthsCount;
                settings.YearViewFirstMonth = newSettings.firstMonthOfYear;

                this.saveUserSettingsToStorage(settings);
            }
        }
    }




    private _onDomMutation(mutationList, observer) {
        //console.debug("_onDomMutation", mutationList, observer);

        topic.publish("/Layout/UpdateTopbarMargin"); // Höhe der Leiste kann sich geändert haben

    }


    // SUCHE MIT ENTITYDLG

    private _onClick_OpenSearch(evt: MouseEvent) {
        if (!this.__searchSettings) return;

        let dlg = new SelectEntityDialog();
        dlg.setConfiguration(this.__searchSettings.selectEntityDlgConfig, lang.hitch(this, this._onSelect_AppointmentInDlg));
    }

    private _onSelect_AppointmentInDlg(value?: any, items?: any) {
        //console.debug("_onSelect_AppointmentInDlg", value, items);
    }

    //// Lifecycle ------------------------------START

    startup() {
        super.startup.apply(this, arguments as any);

        setTimeout(lang.hitch(this, function () {
            if (this.loadingMessage) {
                domClass.remove(this.loadingMessage, "hide");
            }
        }), 1000);

        //this._setupSubscriptions(); // -> ist schon in Vererbung!!

        this.getCurrentUserId(lang.hitch(this, this._setupUserProperties)); // zuerst auf die Usersession warten, damit letzte Einstellungen ausm localstorage geladen werden!
        //this._setupUserProperties(); 

        let sideBarNode = document.getElementById("sidebar_content_top");

        //this.controlContainer.style.width = document.getElementById("mySidebar").style.width; // wozu?
        domConstruct.place(this.controlContainer, sideBarNode);

        this.setTitles(this.translate("General_Label_Calendar"));

        //window.sidebar.pinSidebar();
        //topic.publish("/Sidebar/Pin")

        if (!this.hasFeature("Webcalendar/DisableEvBookingEditor")) {
            if (this.currentPreConfig?.checkCreateAppointmentPrivileges !== false) {
                this._checkCreateAppointmentPrivilege();
            }
        }
        if (this.hasFeature("Webcalendar/PrivateAppointmentHandle")) {
            this._checkCreatePrivateAppointmentPrivilege();
        }

        if (this.hasFeature("Webcalendar/YearViews")) {
            // Startmonate füllen
            let dummyDate = new Date();
            let currentMonthValue = dummyDate.getMonth();

            let values: Array<{ value: number, label: string }> = [];
            for (let i = 0; i < 12; i++) {
                dummyDate.setMonth(i, 1);
                let label = DateHelpers.dateToString(dummyDate, "MMMM");
                values.push({
                    label: label,
                    value: dummyDate.getMonth()
                });

            }

            this.inputYearViewStartMonth.setData(currentMonthValue, values, "value", "label", true);

            values = [];
            for (let i = 6; i <= 14; i++) {
                values.push({
                    label: i.toString(),
                    value: i
                });
            }

            this.inputYearViewMonthCount.setData(12, values, "value", "label", true);
        }


        let urlViewAction = this.getUrlParameterValue("vm");
        if (urlViewAction) {
            this._overrideViewMode = urlViewAction;
        }

        if (typeof this.isDndEditingEnabled != "undefined") {
            this.setIsDndEditingEnabled(this.isDndEditingEnabled);
        }

        if (typeof this.itemClickFunction == "undefined") {
            this.itemClickFunction = this.openDefaultDetailView; // default
        }


    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.useStandbyManager = true;

        // Den Original-URL-DS-Wert sofort cachen, bevor irgendein SyncFusion-internes Scroll-Event
        // den URL-Parameter durch _delaySetUrlParameterDS überschreiben kann.
        // setDefaultView läuft asynchron erst nach der User-Properties-Response - bis dahin kann
        // SyncFusion durch initiales Rendern bereits scroll-Events triggern die ds=heute schreiben,
        // und setDefaultView würde dann diesen überschriebenen Wert als „Restore-Target" lesen.
        this._restoredUrlDs = this.getUrlParameterValue("ds");

        if (this.__requestItemLimit < 2 || !this.__requestItemLimit) {
            this.__requestItemLimit = 400;
        }

        if (window.msTeamsSimpleApi.isCurrentlyRunningInTeamsTab) {
            window.msTeamsSimpleApi.helperFn.stateGet("ego_CalendarSettings").then((res: string) => {
                if (res.trim() == "") { //leerer string == null
                    window.localStorageShim.removeItem("ego_CalendarSettings");
                } else {
                    window.localStorageShim.setItem("ego_CalendarSettings", res);
                }
            });
        }

        this.RequestManager.handleAs = "json";

        this.customPanes = [];
        this.buttonsToAdd = [];

        this.datePicker.on("paging", lang.hitch(this, this._onDatePickerPaging));
        this.datePicker.on("selectmonth", lang.hitch(this, this._onDatePickerMonthSelect));

        this._enableLocalUserSettings = this.hasFeature("Webcalendar/SaveUserSettings");
        this.UiModder.domClass.toggle(this.domNode, "wc_NoLabelWrap", this.hasFeature("Webcalendar/NoLabelWrap"));
        this.UiModder.domClass.toggle(this.domNode, "wc_NoMainLabelWrap", this.hasFeature("Webcalendar/NoMainLabelWrap"));
        this.UiModder.domClass.toggle(this.domNode, "wc_NoSecondaryLabelWrap", this.hasFeature("Webcalendar/NoSecondaryLabelWrap"));
        this.UiModder.domClass.toggle(this.domNode, "wc_NoTimeLabelWrap", this.hasFeature("Webcalendar/NoSecondaryLabelWrap"));
        this.UiModder.domClass.toggle(this.domNode, "wc_SecondaryLabelFirst", this.hasFeature("Webcalendar/SecondaryLabelFirst"));

        this.hideNode(this.quickSearchContainer, !this.hasFeature("Webcalendar/Quicksearch"));

        if (!this.hasFeature("Webcalendar/Searchpanel")) {
            this.removePane(WebcalendarTypes.WebCalendar_DefaultPanes.searchPane);
        }

        this.hideNode(this.googleAppointment_container, true);
        if (this.hasFeature("User/GoogleSyncManager")) {
            this._loadGoogleSyncSettings();

            this.RequestManager.callfunction("Webtool_API_GoogleSync__IsSyncEnabled", {},
                lang.hitch(this, function (response: { enabled: boolean }) {
                    this.googleSyncAvailable = response.enabled;

                    this.hideNode(this.googleAppointment_container, !this.googleSyncAvailable);
                }), lang.hitch(this, function (error) {
                }));
        }

        //let observer = new MutationObserver(lang.hitch(this, this._onDomMutation));
        //let topBar_item_right = document.getElementById("mainMenuGlobalSpace");

        //observer.observe(topBar_item_right, { childList: true });

    }

}

export default mdsWidget(MainPropertiesV2);
